<template>
  <div>
    <div v-if="this.loadpage == true" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>

    <b-card v-if="checkStatus == 'success' && this.loadpage == false" no-body>
      <b-card-header header-bg-variant="light" header-border-variant="secondary">
        <h4 class="font-weight-bolder">เลขที่ใบสั่งซื้อ : {{this.orderId}}</h4>
      </b-card-header>
      <b-card-body body-border-variant="secondary">
        <b-row>
          <b-col class="col-12 col-md-10 col-lg-10">
            <b-row class="pt-1 pb-1 pb-md-0">
              <b-col class="col-4 col-md-3 px-0 pl-md-1">
                <div>ประเภท :</div>
              </b-col>
              <b-col class="pl-lg-0 pr-0">
                <div v-if="this.checkType == '1'">แบบปลีก</div>
                <div v-else>แบบกิโล</div>
              </b-col>
            </b-row>
            <b-row class="pb-1 pb-md-0">
              <b-col class="col-4 col-md-3 px-0 pl-md-1">
                <div>รูปแบบการจัดส่ง :</div>
              </b-col>
              <b-col class="pl-lg-0 pr-0">
                <div>{{ this.orderDetail.expressCompanyName }}</div>
              </b-col>
            </b-row>
            <b-row class="pb-1 pb-md-0">
              <b-col class="col-4 col-md-3 px-0 pl-md-1">
                <div>ส่งในนาม :</div>
              </b-col>
              <b-col class="pl-lg-0 pr-0">
                <div>{{ this.orderDetail.senderAddress }}</div>
              </b-col>
            </b-row>
            <b-row class="pb-1 pb-md-0">
              <b-col class="col-4 col-md-3 px-0 pl-md-1">
                <div>ที่อยู่จัดส่ง :</div>
              </b-col>
              <b-col class="pl-lg-0 pr-0">
                <div>{{ this.orderDetail.receiveAddress }}</div>
              </b-col>
            </b-row>
            <b-row class="pb-1 pb-md-0">
              <b-col class="col-4 col-md-3 px-0 pl-md-1">
                <div>ขนส่ง :</div>
              </b-col>
              <b-col class="pl-lg-0 pr-0">
                <div>{{ this.orderDetail.transportType }}</div>
              </b-col>
            </b-row>
            <b-row class="pb-1 pb-md-0">
              <b-col class="col-4 col-md-3 px-0 pl-md-1">
                <div>หมายเหตุ :</div>
              </b-col>
              <b-col class="pl-lg-0 pr-0">
                <div>{{ this.orderDetail.remark }}</div>
              </b-col>
            </b-row>
            <b-row class="pb-1 pb-md-0">
              <b-col class="col-4 col-md-3 px-0 pl-md-1">
                <div>อัตราแลกเปลี่ยน :</div>
              </b-col>
              <b-col class="pl-lg-0 pr-0">
                <div>{{ this.orderDetail.exchangeRate }}</div>
              </b-col>
            </b-row>
            <b-row class="pb-1 pb-md-0">
              <b-col class="col-4 col-md-3 px-0 pl-md-1">
                <div>สถานะออเดอร์ :</div>
              </b-col>
              <b-col class="pl-lg-0 pr-0">
                <!-- โหมดแสดงผล -->
                <div v-if="!editingStatus" class="d-flex align-items-center">
                  <span>{{ this.orderDetail.statusDescription }}</span>
                  <b-button
                    variant="flat-primary"
                    class="btn-icon rounded-circle ml-50 p-25"
                    size="sm"
                    @click="startEditStatus()"
                  >
                    <feather-icon icon="EditIcon" size="16" />
                  </b-button>
                </div>
                <!-- โหมดแก้ไข: dropdown + ปุ่มบันทึก -->
                <div v-else class="d-md-flex align-items-center">
                  <v-select
                    v-model="selectedStatus"
                    :options="statusOptions"
                    label="statusText"
                    :clearable="false"
                    class="status-select"
                    style="min-width: 200px;"
                  />
                  <div class="mt-1 mt-md-0 ml-md-1">
                    <b-button
                      variant="primary"
                      size="sm"
                      class="mr-50"
                      :disabled="savingStatus || !selectedStatus"
                      @click="saveStatus()"
                    >
                      <b-spinner v-if="savingStatus" small />
                      บันทึก
                    </b-button>
                    <b-button
                      variant="outline-secondary"
                      size="sm"
                      :disabled="savingStatus"
                      @click="cancelEditStatus()"
                    >
                      ยกเลิก
                    </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="text-md-right text-lg-right pt-lg-1 pb-1 pt-md-1 pr-lg-1 pr-md-1 pl-0">
            <b-button v-if="this.orderDetail.statusID <= 3" variant="primary" v-b-modal.edit size="sm">
              แก้ไข
            </b-button>
          </b-col>
        </b-row>
        <!-- pc timeline -->
        <div class="pt-2 d-none d-sm-block">
          <h3 class="text-center">สถานะออเดอร์</h3>
          <app-timeline class="d-flex justify-content-center">
            <app-timeline-item
              :title="this.orderDetail.statusList[0].status"
              :color="this.orderDetail.statusList[0].isActive == false ? 'text-secondary': null"
              :variant="this.orderDetail.statusList[0].isActive == true ? 'success': 'secondary'"
              icon="FileTextIcon"
            />
            <div class="pr-2 d-none d-sm-block">
              <feather-icon
                class="icon"
                :class="this.orderDetail.statusList[0].isActive == false ? 'text-secondary': null"
                icon="ChevronRightIcon"
                size="15"
              />
            </div>
            <app-timeline-item
              :title="this.orderDetail.statusList[1].status"
              :color="this.orderDetail.statusList[1].isActive == false ? 'text-secondary': null"
              :variant="this.orderDetail.statusList[1].isActive == true ? 'success': 'secondary'"
              icon="CreditCardIcon"
            />
            <div class="pr-2 d-none d-sm-block">
              <feather-icon
                class="icon"
                :class="this.orderDetail.statusList[1].isActive == false ? 'text-secondary': null"
                icon="ChevronRightIcon"
                size="15"
              />
            </div>
            <app-timeline-item
              :title="this.orderDetail.statusList[2].status"
              :color="this.orderDetail.statusList[2].isActive == false ? 'text-secondary': null"
              :variant="this.orderDetail.statusList[2].isActive == true ? 'success': 'secondary'"
              icon="PackageIcon"
            />
            <div class="pr-2 d-none d-sm-block">
              <feather-icon
                class="icon"
                :class="this.orderDetail.statusList[2].isActive == false ? 'text-secondary': null"
                icon="ChevronRightIcon"
                size="15"
              />
            </div>
            <app-timeline-item
              :title="this.orderDetail.statusList[3].status"
              :color="this.orderDetail.statusList[3].isActive == false ? 'text-secondary': null"
              :variant="this.orderDetail.statusList[3].isActive == true ? 'success': 'secondary'"
              icon="TruckIcon"
            />
            <div class="pr-2 d-none d-sm-block">
              <feather-icon
                class="icon"
                :class="this.orderDetail.statusList[3].isActive == false ? 'text-secondary': null"
                icon="ChevronRightIcon"
                size="15"
              />
            </div>
            <app-timeline-item
              :title="this.orderDetail.statusList[4].status"
              :color="this.orderDetail.statusList[4].isActive == false ? 'text-secondary': null"
              :variant="this.orderDetail.statusList[4].isActive == true ? 'success': 'secondary'"
              icon="CheckCircleIcon"
            />
          </app-timeline>
        </div>
        <!-- mobile timeline -->
        <div>
          <div class="d-block d-sm-none" role="tablist" no-body>
            <b-card-header header-tag="header" class="px-0 py-0" role="tab">
              <h3>สถานะออเดอร์</h3>
              <div>
                <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="flat-primary"
                  class="btn-icon rounded-circle pr-0"
                  v-b-toggle="'status'"
                >
                  <span class="when-opened">
                    <feather-icon icon="ChevronUpIcon" />
                  </span>
                  <span class="when-closed">
                    <feather-icon icon="ChevronDownIcon" />
                  </span>
                </b-button>
              </div>
            </b-card-header>
            <b-collapse :id="'status'" accordion="status" role="tabpanel">
              <b-card-body class="py-0">
                <app-timeline class="justify-content-center">
                  <app-timeline-item
                    :title="this.orderDetail.statusList[0].status"
                    :color="this.orderDetail.statusList[0].isActive == false ? 'text-secondary': null"
                    :variant="this.orderDetail.statusList[0].isActive == true ? 'success': 'secondary'"
                    icon="FileTextIcon"
                  />
                  <app-timeline-item
                    :title="this.orderDetail.statusList[1].status"
                    :color="this.orderDetail.statusList[1].isActive == false ? 'text-secondary': null"
                    :variant="this.orderDetail.statusList[1].isActive == true ? 'success': 'secondary'"
                    icon="CreditCardIcon"
                  />
                  <app-timeline-item
                    :title="this.orderDetail.statusList[2].status"
                    :color="this.orderDetail.statusList[2].isActive == false ? 'text-secondary': null"
                    :variant="this.orderDetail.statusList[2].isActive == true ? 'success': 'secondary'"
                    icon="PackageIcon"
                  />
                  <app-timeline-item
                    :title="this.orderDetail.statusList[3].status"
                    :color="this.orderDetail.statusList[3].isActive == false ? 'text-secondary': null"
                    :variant="this.orderDetail.statusList[3].isActive == true ? 'success': 'secondary'"
                    icon="TruckIcon"
                  />
                  <app-timeline-item
                    :title="this.orderDetail.statusList[4].status"
                    :color="this.orderDetail.statusList[4].isActive == false ? 'text-secondary': null"
                    :variant="this.orderDetail.statusList[4].isActive == true ? 'success': 'secondary'"
                    icon="CheckCircleIcon"
                  />
                </app-timeline>
              </b-card-body>
            </b-collapse>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <div v-if="checkStatus == 'success' && this.loadpage == false && orderDetail.statusID <= 3" class="pb-1" >
      <b-button variant="primary" size="sm" @click="openSearchModal">เพิ่มสินค้า</b-button>
    </div>

    <div v-if="this.orderDetail != null && this.loadpage == false" class="pb-5">
      <b-card v-for="order in orderDetail.supplier" :key="order.length" no-body class="px-1 py-1">
        <b-card-header class="px-0 py-0">
          <h4 class="font-weight-bolder">ร้านค้า : {{order.supplierName}}</h4>
          <h5 class="font-weight-bolder">{{format_price(order.totalPriceReceivedBaht)}} ฿</h5>
        </b-card-header>
        <hr class="dense">

        <!-- pc timeline orders -->
        <div v-if="order.trackStatuses[0].trackingNo != '' && order.trackStatuses[0].trackingNo != 'ของหมด'">
          <div v-for="track in order.trackStatuses" :key="track.length" class="pb-lg-3 d-none d-sm-block">
            <b-card-header class="px-0 py-0 align-items-center">
              <h5 class="font-weight-bolder mb-1">TrackingNo : <u>{{track.trackingNo}}</u></h5>
              <!-- <b-button v-if="checkType == '2'&&track.arrivedThaiDate" variant="primary" size="sm" :to="{ name: 'customer-shipping-inform' }">แจ้งออกของ</b-button> -->
            </b-card-header>
            <app-timeline class="d-lg-flex justify-content-center">
              <div class="d-flex justify-content-center">
                <app-timeline-item
                  title="ร้านค้าส่งออก"
                  icon="PackageIcon"
                  :time="track.shipDate"
                  :variant="track.shipDate ? 'success': 'secondary'"
                  :color="!track.shipDate ? 'text-secondary' : null"
                />
                <div class="pr-2 d-none d-sm-block">
                  <feather-icon
                    class="icon"
                    :class="!track.shipDate ? 'text-secondary' : null"
                    icon="ChevronRightIcon"
                    size="15"
                  />
                </div>
                <app-timeline-item
                  title="เข้าโกดังจีน"
                  icon="HomeIcon"
                  :time="track.receiveDate"
                  :variant="track.receiveDate ? 'success': 'secondary'"
                  :color="!track.receiveDate ? 'text-secondary' : null"
                />
                <div class="pr-2 d-none d-sm-block">
                  <feather-icon
                    class="icon"
                    :class="!track.receiveDate ? 'text-secondary' : null"
                    icon="ChevronRightIcon"
                    size="15"
                  />
                </div>
                <app-timeline-item
                  title="ออกจากจีน"
                  icon="TruckIcon"
                  :time="track.offChinaDate"
                  :variant="track.offChinaDate ? 'success': 'secondary'"
                  :color="!track.offChinaDate ? 'text-secondary' : null"
                />
              </div>
              <div class="d-flex justify-content-center">
                <div class="pr-2 d-none d-sm-block">
                  <feather-icon
                    class="icon"
                    :class="!track.offChinaDate ? 'text-secondary' : null"
                    icon="ChevronRightIcon"
                    size="15"
                  />
                </div>
                <app-timeline-item
                  title="ประมาณการถึงไทย"
                  icon="MapPinIcon"
                  :time="track.expectedArrival"
                  :variant="track.expectedArrival ? 'success': 'secondary'"
                  :color="!track.expectedArrival ? 'text-secondary' : null"
                />
                <div class="pr-2 d-none d-sm-block">
                  <feather-icon
                    class="icon"
                    :class="!track.expectedArrival ? 'text-secondary' : null"
                    icon="ChevronRightIcon"
                    size="15"
                  />
                </div>
                <app-timeline-item
                  title="ถึงไทยวันที่"
                  icon="HomeIcon"
                  :time="track.arrivedThaiDate"
                  :variant="track.arrivedThaiDate ? 'success': 'secondary'"
                  :color="!track.arrivedThaiDate ? 'text-secondary' : null"
                />
              </div>
            </app-timeline>
          </div>
        </div>

        <!-- mobile timeline orders -->
        <div v-if="order.trackStatuses[0].trackingNo != '' && order.trackStatuses[0].trackingNo != 'ของหมด'">
          <b-card v-for="(track, index) in order.trackStatuses" :key="index" class="d-block d-sm-none" role="tablist" no-body>
            <b-card-header header-tag="header" class="px-0 py-0" role="tab">
              <h5 class="font-weight-bolder mb-1">TrackingNo : <u>{{track.trackingNo}}</u></h5>
              <b-container>
                <b-row>
                  <b-col class="px-0">
                    <span>{{trackStatusList.length != 0 && trackStatusList.filter(x => x.track == track.trackingNo).length != 0 ? trackStatusList.filter(x => x.track == track.trackingNo)[0].status : null}}</span>
                  </b-col>
                  <b-col class="text-right px-0">
                    <span>{{trackStatusList.length != 0 && trackStatusList.filter(x => x.track == track.trackingNo).length != 0 ? trackStatusList.filter(x => x.track == track.trackingNo)[0].date : null}}</span>
                  </b-col>
                </b-row>
                <div class="text-right">
                  <b-button
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="flat-primary"
                    class="btn-icon rounded-circle pr-0"
                    v-b-toggle="'track-'+index"
                  >
                    <span class="when-opened">
                      <feather-icon icon="ChevronUpIcon" />
                    </span>
                    <span class="when-closed">
                      <feather-icon icon="ChevronDownIcon" />
                    </span>
                  </b-button>
                </div>
              </b-container>
            </b-card-header>
            <b-collapse :id="'track-'+index" accordion="track" role="tabpanel">
              <b-card-body class="py-0">
                <app-timeline>
                  <app-timeline-item
                    title="ร้านค้าส่งออก"
                    icon="PackageIcon"
                    :time="track.shipDate"
                    :variant="track.shipDate ? 'success': 'secondary'"
                    :color="!track.shipDate ? 'text-secondary' : null"
                  />
                  <app-timeline-item
                    title="เข้าโกดังจีน"
                    icon="HomeIcon"
                    :time="track.receiveDate"
                    :variant="track.receiveDate ? 'success': 'secondary'"
                    :color="!track.receiveDate ? 'text-secondary' : null"
                  />
                  <app-timeline-item
                    title="ออกจากจีน"
                    icon="TruckIcon"
                    :time="track.offChinaDate"
                    :variant="track.offChinaDate ? 'success': 'secondary'"
                    :color="!track.offChinaDate ? 'text-secondary' : null"
                  />
                  <app-timeline-item
                    title="ประมาณการถึงไทย"
                    icon="MapPinIcon"
                    :time="track.expectedArrival"
                    :variant="track.expectedArrival ? 'success': 'secondary'"
                    :color="!track.expectedArrival ? 'text-secondary' : null"
                  />
                  <app-timeline-item
                    title="ถึงไทยวันที่"
                    icon="HomeIcon"
                    :time="track.arrivedThaiDate"
                    :variant="track.arrivedThaiDate ? 'success': 'secondary'"
                    :color="!track.arrivedThaiDate ? 'text-secondary' : null"
                  />
                </app-timeline>
              </b-card-body>
            </b-collapse>
            <hr class="dense my-0">
          </b-card>
        </div>

        <div class="pb-1">
          <h5>การตีลัง : {{order.makeBoxText}}</h5>
          <h5>ค่าส่งในจีน : {{order.chinesePost}} ¥ = {{order.chinesePostBaht}} ฿</h5>
        </div>

        <!-- pc -->
        <b-table
          responsive
          bordered
          :items="order.orderItems"
          :fields="orderItemsFields"
          :tbody-tr-class="rowColor"
          class="d-none d-sm-block"
        >
          <template #cell(no)="data">
            <div style="width:50px">
              {{data.value}}
            </div>
          </template>
          <template #cell(photoLink)="data">
            <b-img :src="data.value" class="cursor-pointer" width="70px" @click="showImg(data.value)"></b-img>
          </template>
          <template #cell(title)="data">
            <div style="width:200px">
              <b-link :href="data.item.productLink" target="_blank">{{data.value}}</b-link>
              <div>สี : {{data.item.color ? data.item.color : '-'}}</div>
              <div>ไซส์ : {{data.item.size ? data.item.size : '-'}}</div>
              <div v-if="data.item.otherOption">อื่นๆ : {{data.item.otherOption}}</div>
            </div>
          </template>
          <template #cell(priceReceived)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(totalPriceReceived)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(retailPrice)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(totalPriceReceivedBaht)="data">
            {{format_price(data.value)}}
          </template>
          <template #cell(itemID)="data">
            <div class="text-nowrap" v-if="orderDetail.statusID <= 3">
              <feather-icon
                :id="`edit-icon-${data.value}`"
                icon="EditIcon"
                size="20"
                class="cursor-pointer text-warning"
                @click="openEditItemModal(data.value)"
              />
              <b-tooltip
                title="แก้ไข"
                :target="`edit-icon-${data.value}`"
                :delay="{show: '1500'}"
              />
              <feather-icon
                :id="`delete-icon-${data.value}`"
                icon="TrashIcon"
                class="cursor-pointer ml-1 text-danger"
                size="20"
                @click="deleteItem(data.value , data.item.title)"
              />
              <b-tooltip
                title="ลบ"
                :target="`delete-icon-${data.value}`"
                :delay="{show: '1500'}"
              />
            </div>
          </template>
        </b-table>

        <!-- mobile -->
        <b-card-body
          v-for="(item, index) in order.orderItems"
          :key="index"
          class="py-0 d-block d-sm-none "
          :body-class="item.backcolor != null ? 'table-' + item.backcolor : null"
        >
          <!-- pc -->
          <!-- <b-row>
            <b-col class="pl-0 pb-1 pb-md-0 col-sm-2 col-md-2 col-lg-1">
              <div class="d-flex">
                <h5 class="pr-1">{{item.no}}</h5>
                <b-img :src="item.photoLink" width="100px" fluid class="cursor-pointer"  @click="showImg(item.photoLink)"></b-img>
              </div>
            </b-col>
            <b-col class="d-none d-sm-block col-md-7 col-lg-9">
              <div class="item-name">
                <h5>
                  <b-link class="text-body" :href="item.productLink" target="_blank">
                    {{ item.title }}
                  </b-link>
                </h5>
              </div>
              <h5>สี : {{item.color ? item.color : "-"}}</h5>
              <h5>ไซส์ : {{item.size ? item.size : "-"}}</h5>
              <h5 v-if="item.retailPrice > 0">ค่านำเข้า : {{format_price(item.retailPrice)}} ฿/ชิ้น</h5>
              <h5>หมายเหตุ : {{item.remarkCustomer ? item.remarkCustomer : "-"}}</h5>
              <h5>หมายเหคุ(ทางร้าน) : {{item.remarkAdmin ? item.remarkAdmin : "-"}}</h5>
            </b-col>
            <b-col class="text-right pr-0 col-sm-10 col-md-3 col-lg-2">
              <h5>{{item.quantityReceived}} x</h5>
              <h5>{{format_price(item.priceReceived)}} ¥</h5>
              <h5>= {{format_price(item.totalPriceReceived)}} ¥</h5>
            </b-col>
          </b-row> -->
          <!-- mobile -->
          <b-row>
            <b-col class="col-3 pl-0">
              <div class="d-flex">
                <span class="pr-1">{{item.no}}</span>
                <b-img :src="item.photoLink" width="100px" fluid class="cursor-pointer"  @click="showImg(item.photoLink)"></b-img>
              </div>
            </b-col>
            <b-col class="pr-0 col-9">
              <div class="item-name" >
                <h5>
                  <b-link class="text-body" :href="item.productLink" target="_blank">
                    {{ item.title }}
                  </b-link>
                </h5>
              </div>
              <h5>สี : {{item.color ? item.color : "-"}}</h5>
              <h5>ไซส์ : {{item.size ? item.size : "-"}}</h5>
              <h5 v-if="item.otherOption">อื่นๆ : {{item.otherOption}}</h5>
              <h5 v-if="item.retailPrice > 0">ค่านำเข้า : {{format_price(item.retailPrice)}} ฿/ชิ้น</h5>
              <h5>หมายเหตุ : {{item.remarkCustomer ? item.remarkCustomer : "-"}}</h5>
              <h5>หมายเหคุ(ทางร้าน) : {{item.remarkAdmin ? item.remarkAdmin : "-"}}</h5>
            </b-col>
          </b-row>
           <b-table
            responsive
            :items="order.orderItems.filter(x => x.itemID == item.itemID)"
            :fields="orderItemsFieldsMobile"
            tbody-tr-class="table-light"
          >
          </b-table>
           <div class="text-right" v-if="orderDetail.statusID <= 3">
            <b-button class="btn-icon" variant="warning" @click="openEditItemModal(item.itemID)">
              <feather-icon class="icon" icon="EditIcon" size="15"/>
            </b-button>
            <b-button class="btn-icon ml-1" variant="danger" @click="deleteItem(item.itemID, item.title)">
              <feather-icon class="icon" icon="Trash2Icon" size="15"/>
            </b-button>
          </div>
          <hr>
        </b-card-body>
      </b-card>
      <div class="pb-1">
        <b-card no-body>
          <div class="pt-1">
            <b-table
              class="position-relative col-md-6 float-right"
              thead-class="hidden_header"
              responsive
              small
              bordered
              :items="stateMents"
              :fields="stateMentsFields"
              :tbody-tr-class="rowClass"
            >
            </b-table>
          </div>
        </b-card>
      </div>
    </div>

    <!-- edit ordes -->
    <b-modal
      id="edit"
      ref="edit"
      size="lg"
      title="แก้ไขข้อมูลออเดอร์"
      title-class="h4"
      hide-footer
      no-close-on-backdrop
      @hidden="closeModalEdit"
    >
      <b-form>
        <b-row>
          <b-col cols="12">
            <b-form-group label="รูปแบบการจัดส่ง :" label-cols-md="12">
              <b-form-radio-group
                v-model="transportId"
                :options="this.transportList"
                text-field="descriptionTH"
                value-field="id"
                class="pl-md-2"
              >
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col v-if="this.checkType == '1'" cols="12" id="domestics">
            <b-form-group label="ขนส่ง :" label-cols-md="12">
              <div class="pl-md-2">
                <v-select
                  class="px-0 col-12"
                  v-model="domesticsId"
                  :options="domesticsList"
                  label="description"
                ></v-select>
                <small v-if="valDomestics == false" class="text-danger">กรุณาเลือกบริษัทขนส่ง</small>
                <b-form-textarea
                  v-model="otherDomestics"
                  v-if="this.domesticsId != null && this.domesticsId.rowId == 11"
                  class="col-md-6 mt-1"
                  placeholder="โปรดระบุชื่อบริษัทขนส่ง"
                />
                <small v-if="valOther == false" class="text-danger">กรุณาระบุชื่อบริษัทขนส่ง</small>
              </div>
            </b-form-group>
          </b-col>
           <b-col v-if="this.checkType == '1'" cols="12" id="cus-address">
            <b-form-group label="ที่อยู่จัดส่ง :" label-cols-md="12">
              <div class="pl-md-2">
                <v-select
                  class="px-0 col-12"
                  v-model="customerAddressId"
                  :options="customerAdressList"
                  label="address"
                ></v-select>
                <small v-if="this.valCustomer == false" class="text-danger pb-3">กรุณาเลือกที่อยู่จัดส่ง</small>
              </div>
            </b-form-group>
          </b-col>
          <b-form-checkbox
            v-if="this.checkType == '1'"
            v-model="checkSender"
            :value="true"
            :unchecked-value="false"
            class="ml-1"
          >
            ต้องการส่งในนาม
          </b-form-checkbox>
          <b-col v-if="this.checkType == '1' && this.checkSender == true" cols="12" id="sender-address">
            <b-form-group label="ที่อยู่ในนาม :" label-cols-md="12">
              <small v-if="this.valSender == false" class="pl-md-2 text-danger pb-3">กรุณาเลือกที่อยู่จัดส่งในนาม ถ้าไม่ต้องการเลือกให้เอาเครื่องหมายถูกต้องออก</small>
              <div class="pl-md-2">
                <v-select
                  class="px-0 col-12"
                  v-model="senderAddressId"
                  :options="senderAddressList"
                  label="address"
                ></v-select>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="text-right">
          <b-button variant="primary" @click="editOrder()">แก้ไข</b-button>
          <b-button class="ml-1" variant="outline-danger" @click="closeModalEdit()">ยกเลิก</b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- edit item -->
    <b-modal
      id="edit-item"
      ref="edit-item"
      title="แก้ไขข้อมูลสินค้า"
      title-class="h4"
      hide-footer
    >
      <b-form>
        <b-row>
          <b-col cols="12">
            <b-form-group label="จำนวน :" label-cols-md="3">
              <b-input-group v-model="inputQuantity" size="sm" class="h-25 mb-1">
                <b-input-group-prepend>
                  <b-button variant="outline-primary" @click="quantity--" :disabled="this.quantity == 1">-</b-button>
                </b-input-group-prepend>
                <b-form-input type="number" min="0.00" v-model="quantity"/>
                <b-input-group-append>
                  <b-button variant="outline-primary" @click="quantity++">+</b-button>
                </b-input-group-append>
              </b-input-group>
              <small v-if="this.valQuantity == false" class="text-danger">กรุณาระบุจำนวนชิ้นมากกว่า 0 ขึ้นไป</small>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="ราคา :" label-cols-md="3">
              <cleave
                v-model="priceOrder"
                class="form-control"
                :raw="false"
                :options="options.priceOrder"
              />
              <small v-if="this.valPrice == false" class="text-danger">กรุณาระบุราคามากกว่า 0 ขึ้นไป</small>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="สี :" label-cols-md="3">
              <b-form-input v-model="color"/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="ไซส์ :" label-cols-md="3">
              <b-form-input v-model="size"/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="ตัวเลือกอื่น :" label-cols-md="3">
              <b-form-input v-model="otherOption"/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="หมายเหตุ :" label-cols-md="3">
              <b-form-textarea v-model="remarkOrder"/>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="text-right">
          <b-button variant="outline-secondary" @click="closeModal()">ยกเลิก</b-button>
          <b-button class="ml-1" variant="primary" @click="editItem()">แก้ไข</b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- add item -->
    <b-modal
      id="add-item"
      ref="add-item"
      title="เพิ่มสินค้า"
      title-class="h4"
      size="xl"
      hide-footer
      @hidden="closeAddItem"
    >
      <div>
        <b-row>
          <b-col>
            <div class="d-md-flex align-items-center">
              <span class="title">วาง Link :</span>
              <b-form-input
                v-model="linkItem"
                class="col-md-6 mx-md-1 my-sm-1 my-md-0"
                placeholder="วาง URL ของสินค้า"
                @keypress.enter="searchProduct"
              />
              <b-button variant="primary" @click="searchProduct()">
                ค้นหา
              </b-button>
            </div>
          </b-col>
        </b-row>

        <b-tabs v-model="tabIndex" class="pt-1">
          <b-tab title="เลือกสินค้า" active>
            <div v-if="this.loadProduct == true" class="text-center pt-3">
              <b-spinner
                style="width: 5rem; height: 5rem;"
                variant="primary"
                label="Large Spinner"
              />
            </div>
            <div>
              <b-row class="my-2">
              <!-- Left: Product Image Container -->
                <b-col md="5">
                  <!-- swiper1 -->
                  <swiper
                    v-if="this.imageIcon == ''"
                    ref="swiperTop"
                    class="swiper-gallery gallery-top "
                    :options="swiperOptions"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  >
                    <swiper-slide v-for="(data,index) in imgList" :key="index">
                      <b-img :src="data" fluid />
                    </swiper-slide>
                    <div slot="button-next" class="swiper-button-next swiper-button-white"/>
                    <div slot="button-prev" class="swiper-button-prev swiper-button-white"/>

                  </swiper>

                  <swiper
                    v-if="this.imageIcon != ''"
                    ref="swiperTop"
                    class="swiper-gallery gallery-top"
                    :options="swiperOptions"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  >
                    <b-img :src="this.imageIcon" fluid/>

                  </swiper>

                  <!-- swiper2 Thumbs -->
                  <swiper
                    ref="swiperThumbs"
                    class="swiper-gallery gallery-top"
                    :options="swiperOptionThumbs"
                    @click="thumbnails()"
                  >
                    <swiper-slide v-for="(data,index) in imgList" :key="index">
                      <b-img :src="data" height="100px"/>
                    </swiper-slide>
                  </swiper>
                </b-col>
                <!-- Right: Product Details -->
                <b-col v-if="this.loadProduct == false && this.srchStatus == true" cols="12" md="7">
                  <!-- Product Name -->
                  <h4 class="font-weight-bolder">{{ prod.title }}</h4>
                  <hr>

                  <!-- rate price -->
                  <div>
                    <!-- 1688 -->
                    <!-- have quantityRange -->
                    <b-row v-if="this.checkShop.product1688 && prod.quantityRange.length >= 2" class="d-flex" style="background-color:#fff4ec;">
                      <b-col class="py-2 ">
                        <h1 class="font-weight-bolder text-danger pb-2 d-none d-sm-flex">ราคา</h1>
                        <h5 class="font-weight-bolder text-danger pb-2 d-flex d-sm-none">ราคา</h5>
                        <h5 class="d-none d-sm-flex">สั่งจำนวน</h5>
                        <h6 class="d-flex d-sm-none">สั่งจำนวน</h6>
                      </b-col>
                      <b-col
                        class="py-2"
                        v-for="index in prod.quantityRange"
                        :key="index.length"
                      >
                        <h1 class="font-weight-bolder text-danger pb-2 d-none d-sm-flex"> {{format_price(index.price.marginPrice)}} <small class="pt-1"> ¥</small></h1>
                        <h5 class="font-weight-bolder text-danger pb-2 d-flex d-sm-none"> {{format_price(index.price.marginPrice)}} <small class="pt-1"> ¥</small></h5>
                        <h5 class="d-none d-sm-flex" v-if="index.maxQuantity != 0">{{index.minQuantity}} - {{index.maxQuantity}} ชิ้น</h5>
                        <h5 class="d-none d-sm-flex" v-if="index.maxQuantity == 0">{{index.minQuantity}} ชิ้นขึ้นไป</h5>
                        <h6 class="d-flex d-sm-none" v-if="index.maxQuantity != 0">{{index.minQuantity}} - {{index.maxQuantity}} ชิ้น</h6>
                        <h6 class="d-flex d-sm-none" v-if="index.maxQuantity == 0">{{index.minQuantity}} ชิ้นขึ้นไป</h6>
                      </b-col>
                    </b-row>

                    <b-row v-if="this.checkShop.product1688 && prod.quantityRange.length == 1" class="d-flex" style="background-color:#fff4ec;">
                      <b-col class="py-2 ">
                        <h1 class="font-weight-bolder text-danger pb-2 d-none d-sm-flex">ราคา</h1>
                        <h5 class="font-weight-bolder text-danger pb-2 d-flex d-sm-none">ราคา</h5>
                        <h5 class="d-none d-sm-flex">สั่งจำนวน</h5>
                        <h6 class="d-flex d-sm-none">สั่งจำนวน</h6>
                      </b-col>
                      <b-col
                        class="py-2"
                        v-for="index in prod.quantityRange"
                        :key="index.length"
                        cols="9"
                      >
                        <h1 class="font-weight-bolder text-danger pb-2 d-none d-sm-flex"> {{format_price(index.price.marginPrice)}} <small class="pt-1"> ¥</small></h1>
                        <h5 class="font-weight-bolder text-danger pb-2 d-flex d-sm-none"> {{format_price(index.price.marginPrice)}} <small class="pt-1"> ¥</small></h5>
                        <h5 class="d-none d-sm-flex" v-if="index.maxQuantity != 0">{{index.minQuantity}} - {{index.maxQuantity}} ชิ้น</h5>
                        <h5 class="d-none d-sm-flex" v-if="index.maxQuantity == 0">{{index.minQuantity}} ชิ้นขึ้นไป</h5>
                        <h6 class="d-flex d-sm-none" v-if="index.maxQuantity != 0">{{index.minQuantity}} - {{index.maxQuantity}} ชิ้น</h6>
                        <h6 class="d-flex d-sm-none" v-if="index.maxQuantity == 0">{{index.minQuantity}} ชิ้นขึ้นไป</h6>
                      </b-col>
                    </b-row>
                    <!-- no quantityRange -->
                    <b-row v-if="this.checkShop.product1688 && prod.quantityRange.length == 0" class="d-flex" style="background-color:#fff4ec;">
                      <b-col class="py-2 ">
                        <h1 class="font-weight-bolder text-danger pb-2 d-none d-sm-flex">ราคา {{format_price(prod.minPrice)}} ¥ - {{format_price(prod.maxPrice)}} ¥</h1>
                        <h5 class="font-weight-bolder text-danger pb-2 d-flex d-sm-none">ราคา {{format_price(prod.minPrice)}} ¥ - {{format_price(prod.maxPrice)}} ¥</h5>
                        <h5 class="d-none d-sm-flex">ขั้นต่ำ {{prod.minimumQuantity}} ชิ้น</h5>
                        <h6 class="d-flex d-sm-none">ขั้นต่ำ {{prod.minimumQuantity}} ชิ้น</h6>
                      </b-col>
                    </b-row>

                    <!-- taobao tmall -->
                    <b-row v-if="this.checkShop.product" style="background-color:#fff4ec;">
                      <b-col v-if="this.pricePerItem == null" class="py-0" >
                        <h1 class="font-weight-bolder text-danger d-none d-sm-flex">ราคา {{this.priceMinMax}} ¥</h1>
                        <h5 class="font-weight-bolder text-danger d-flex d-sm-none">ราคา {{this.priceMinMax}} ¥</h5>
                      </b-col>
                      <b-col v-else class="py-0" >
                        <h1 class="font-weight-bolder text-danger d-none d-sm-flex">ราคา {{this.pricePerItem}} ¥</h1>
                        <h5 class="font-weight-bolder text-danger d-flex d-sm-none">ราคา {{this.pricePerItem}} ¥</h5>
                      </b-col>
                    </b-row>
                  </div>

                  <!-- product info -->
                  <!-- 1688 -->
                  <div v-if="this.checkShop.product1688">
                    <!-- prop มี 0 -->
                    <b-row v-if="this.prod.listOfProp.length == 0" class="pt-2">
                      <b-col class="col-12 col-lg-2">
                        <h5>จำนวน</h5>
                      </b-col>
                      <b-col class="col-12 col-lg-3">
                        <b-input-group v-model="bInputGroup" size="sm" class="h-25">
                          <b-input-group-prepend>
                            <b-button variant="outline-primary" @click="value--" :disabled="this.value == this.prod.minimumQuantity">-</b-button>
                          </b-input-group-prepend>

                          <b-form-input type="number" min="0.00" v-model="value"></b-form-input>

                          <b-input-group-append>
                            <b-button variant="outline-primary" @click="value++">+</b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-col>
                    </b-row>
                    <!-- prop มี 1 -->
                    <div v-if="this.prod.listOfProp.length == 1">
                      <b-row>
                        <div class="pt-1 col-lg-2">
                          <h5 >{{this.prod.listOfProp[0].thaiName}}</h5>
                        </div>
                        <div class="pt-1 col">
                          <b-row>
                            <b-col class="">
                            </b-col>
                            <b-col class="text-right">
                              <h5>ราคา</h5>
                            </b-col>
                            <b-col class="text-right">
                              <h5>จำนวน</h5>
                            </b-col>
                            <b-col class="text-right" cols="4">
                              <h5>เลือก</h5>
                            </b-col>
                          </b-row>
                          <hr>
                          <b-row v-for="propItem in prod.propItemCombination1688" :key="propItem.length" class="pt-1">
                            <b-col>
                              <b-img
                                v-if="propItem.isShowImg"
                                :id="`1688-prop1-${propItem.propPath}`"
                                :src="propItem.prop2Img"
                                :alt="propItem.prop2Img"
                                :title="propItem.prop2Value"
                                @mouseover="changeImg(propItem.prop2Img)"
                                width="50px"
                                height="50px"
                              />
                              <h5 v-else :id="`1688-prop1-${propItem.propPath}`">{{propItem.prop2Value}}</h5>
                              <b-tooltip
                                :title="propItem.tooltip"
                                :target="`1688-prop1-${propItem.propPath}`"
                              />
                            </b-col>
                            <b-col class="text-right">
                              <h5>{{ (yuanPriceFromQuantityRange === null) ? propItem.price : yuanPriceFromQuantityRange}} ¥</h5>
                            </b-col>
                            <b-col class="text-right">
                              <h5>{{propItem.quantity}}</h5>
                            </b-col>
                            <b-col cols="4">
                              <b-input-group v-model="bInputGroup" v-if="propItem.quantity != 0" size="sm" class="h-25">
                                <b-input-group-prepend>
                                  <b-button variant="outline-primary" @click="propItem.quantityInput--" :disabled="propItem.quantityInput == 0">-</b-button>
                                </b-input-group-prepend>

                                <b-form-input type="number" min="0.00" v-model="propItem.quantityInput"></b-form-input>

                                <b-input-group-append>
                                  <b-button variant="outline-primary" @click="propItem.quantityInput++">+</b-button>
                                </b-input-group-append>
                              </b-input-group>
                            </b-col>
                          </b-row>
                        </div>
                      </b-row>
                    </div>
                    <!-- prop มี 2 -->
                    <b-row v-if="this.prod.listOfProp.length == 2">
                      <!-- Prop 1 Item -->
                      <b-col cols="12">
                        <b-row>
                          <b-col class="pt-1 col-lg-2">
                            <h5>
                              {{this.prod.listOfProp[0].thaiName}}
                            </h5>
                          </b-col>
                          <b-col class="pt-1">
                            <span
                              v-for="propItem in prod.listOfProp[0].listOfPropItem"
                              :key="propItem.propPath"
                            >
                              <b-form-radio
                                button
                                :button-variant="prop1ID == propItem.propPath ? 'outline-primary btn-icon' : 'outline-secondary btn-icon'"
                                style="padding:3px"
                                @click="prop1ID = propItem.propPath"
                                @change="changeImg(propItem.image)"
                                v-model="prop1ID"
                                :value="propItem.propPath"
                              >
                                <b-img
                                  v-if="propItem.isShowImage"
                                  :id="`1688-prop2-${propItem.propPath}-1`"
                                  :src="propItem.image"
                                  :alt="propItem.image"
                                  width="30px"
                                  height="30px"
                                />
                                <h5 v-else :id="`1688-prop2-${propItem.propPath}-1`">{{propItem.name}}</h5>
                                <b-tooltip
                                  :title="propItem.tooltipName"
                                  :target="`1688-prop2-${propItem.propPath}-1`"
                                />
                              </b-form-radio>
                            </span>
                          </b-col>
                        </b-row>
                      </b-col>
                        <!-- Prop 2 Item -->
                      <b-col cols="12 pt-1">
                        <br>
                        <b-row>
                          <b-col cols="2">
                            <h5>{{this.prod.listOfProp[1].thaiName}}</h5>
                          </b-col>
                          <b-col class="pt-1 col-lg-2">
                            <b-row>
                              <b-col class="">
                              </b-col>
                              <b-col class="text-right">
                                <h5>ราคา</h5>
                              </b-col>
                              <b-col class="text-right">
                                <h5>จำนวน</h5>
                              </b-col>
                              <b-col class="text-center col-md-5 col-lg-4">
                                <h5>เลือก</h5>
                              </b-col>
                            </b-row>
                            <hr>
                            <b-row v-for="group, groupName in groups">
                              <b-col cols="12">
                                <b-row v-for="item in group.filter(x => x.prop1ID == prop1ID)" :key="item.propPath" class="pt-1">
                                  <b-col>
                                    <div :id="`1688-prop2-${item.propPath}-2`">{{ item.prop2Value }}</div>
                                    <b-tooltip
                                      :title="item.tooltip"
                                      :target="`1688-prop2-${item.propPath}-2`"
                                    />
                                  </b-col>
                                  <b-col class="text-right">
                                    {{ (yuanPriceFromQuantityRange === null) ? item.price : yuanPriceFromQuantityRange }} ¥
                                  </b-col>
                                  <b-col class="text-right">
                                    {{ item.quantity }}
                                  </b-col>
                                  <b-col class="col-md-5 col-lg-4">
                                    <b-input-group v-model="bInputGroup" v-if="item.quantity != 0" size="sm" class="h-25">
                                      <b-input-group-prepend>
                                        <b-button variant="outline-primary" @click="item.quantityInput--" :disabled="item.quantityInput == 0">-</b-button>
                                      </b-input-group-prepend>

                                      <b-form-input type="number" min="0" v-model="item.quantityInput"></b-form-input>

                                      <b-input-group-append>
                                        <b-button variant="outline-primary" @click="item.quantityInput++">+</b-button>
                                      </b-input-group-append>
                                    </b-input-group>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </div>

                  <!-- taobao -->
                  <div v-if="this.checkShop.product">
                    <b-row v-for="(prop, index) in prod.listOfProp" :key="index">
                      <b-col cols="12">
                        <b-row>
                          <b-col class="pt-1 col-12 col-md-2">
                            <h5 >{{prop.thaiName}}</h5>
                          </b-col>
                          <b-col class="pt-1 col-12 col-md-10">
                            <span v-for="(propItem, array) in prop.listOfPropItem" :key="array">
                              <b-form-radio
                                v-if="index == 1 && checkStock1.filter( x => x.path == propItem.propPath && x.quantity != 0) != ''"
                                button
                                :button-variant=" propItem.propPath == prop1 ? 'outline-primary btn-icon' : 'outline-secondary btn-icon'"
                                style="padding:3px"
                                v-model="prop1"
                                :value="propItem.propPath"
                                @change="selectprop1(propItem.propPath, propItem.image, propItem.name, propItem.isShowImage)"
                              >
                                <b-img
                                  v-if="propItem.isShowImage"
                                  :src="propItem.image"
                                  :alt="propItem.image"
                                  :id="`taobao-prop1-${propItem.propPath}`"
                                  width="30px" height="30px"
                                />
                                <h5
                                  v-if="propItem.isShowText"
                                  :id="`taobao-prop1-${propItem.propPath}`"
                                >
                                  {{propItem.name}}
                                </h5>
                                <b-tooltip
                                  :title="propItem.tooltipName"
                                  :target="`taobao-prop1-${propItem.propPath}`"
                                />
                              </b-form-radio>
                            </span>
                            <span v-for="propItem in prop.listOfPropItem" :key="propItem.length">
                              <b-form-radio
                                v-if="index == 0 && checkStock2.filter( x => x.path == propItem.propPath && x.quantity != 0) != ''"
                                button
                                :button-variant=" propItem.propPath == prop2 ? 'outline-primary btn-icon' : 'outline-secondary btn-icon'"
                                style="padding:3px"
                                v-model="prop2"
                                :value="propItem.propPath"
                                @change="selectprop2(propItem.propPath, propItem.image, propItem.name, propItem.isShowImage)"
                              >
                                <b-img
                                  v-if="propItem.isShowImage"
                                  :src="propItem.image"
                                  :alt="propItem.image"
                                  :id="`taobao-prop2-${propItem.propPath}`"
                                  width="30px" height="30px"
                                />
                                <h5
                                  v-if="propItem.isShowText"
                                  :id="`taobao-prop2-${propItem.propPath}`"
                                >
                                  {{propItem.name}}
                                </h5>
                                <b-tooltip
                                  :title="propItem.tooltipName"
                                  :target="`taobao-prop2-${propItem.propPath}`"
                                />
                              </b-form-radio>
                            </span>
                            <span v-for="propItem in prop.listOfPropItem" :key="propItem.length">
                              <b-form-radio
                                v-if="index == 2 && checkStock3.filter( x => x.path == propItem.propPath && x.quantity != 0) != ''"
                                button
                                :button-variant=" propItem.propPath == prop3 ? 'outline-primary btn-icon' : 'outline-secondary btn-icon'"
                                style="padding:3px"
                                v-model="prop3"
                                :value="propItem.propPath"
                                @change="selectprop3(propItem.propPath, propItem.image, propItem.name, propItem.isShowImage)"
                              >
                                <b-img
                                  v-if="propItem.isShowImage"
                                  :src="propItem.image"
                                  :alt="propItem.image"
                                  :id="`taobao-prop1-${propItem.propPath}`"
                                  width="30px" height="30px"
                                />
                                <h5
                                  v-if="propItem.isShowText"
                                  :id="`taobao-prop1-${propItem.propPath}`"
                                >
                                  {{propItem.name}}
                                </h5>
                                <b-tooltip
                                  :title="propItem.tooltipName"
                                  :target="`taobao-prop1-${propItem.propPath}`"
                                />
                              </b-form-radio>
                            </span>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </div>

                  <!-- ราคา & จำนวน -->
                  <!-- taobao -->
                  <div class="pt-2 pt-md-4" v-if="this.checkShop.product">
                    <b-row >
                      <b-col class="col-md-2 col-12">
                        <h5>จำนวน</h5>
                      </b-col>
                      <!-- taobao -->
                      <b-col class="col-md-4 col-12">
                        <!-- <b-form-spinbutton v-model="valueTaobao" min="1" max="10000000" class="h-100"/> -->
                        <b-input-group v-model="bInputGroup" size="sm" class="h-25">
                          <b-input-group-prepend>
                            <b-button variant="outline-primary" @click="valueTaobao--" :disabled="valueTaobao == 1">-</b-button>
                          </b-input-group-prepend>

                          <b-form-input type="number" min="0.00" v-model="valueTaobao"></b-form-input>

                          <b-input-group-append>
                            <b-button variant="outline-primary" @click="valueTaobao++">+</b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-col>
                      <b-col v-if="this.checkQuanAndButton == true">
                        <h5 v-if="this.quanOfProp != 0">มีสินค้าท้ังหมด {{this.quanOfProp}} ชิ้น</h5>
                        <h5 v-else>(ไม่มีสินค้าในสต๊อก)</h5>
                      </b-col>
                    </b-row>
                  </div>
                  <!-- หมายเหตุ -->
                  <div class="pt-2" v-if="this.checkShop">
                    <b-row >
                      <b-col class="col-lg-2 col-12">
                        <h5>หมายเหตุ</h5>
                      </b-col>
                      <b-col >
                        <b-form-textarea
                          v-model="remark"
                          id="textarea-default"
                          rows="2"
                        />
                      </b-col>
                    </b-row>
                  </div>
                  <!-- สรุป -->
                  <!-- 1688 -->
                  <div class="pt-2" v-if="checkShop.product1688">
                    <b-row>
                      <b-col cols="2" class="d-none d-sm-block"/>
                      <b-col class="pr-0" style="background-color:#fff4ec;">
                        <h1 v-if="this.prod.listOfProp.length != 0" class="font-weight-bolder text-danger py-1">ทั้งหมด {{this.quantityProd.map(i => parseInt(i.quantityInput)).reduce((a, b) => a + b)}} ชิ้น | {{totalYuanPrice}} <small>¥</small></h1>
                        <h1 v-if="this.prod.listOfProp.length == 0 && this.prod.quantityRange.length <= 1" class="font-weight-bolder text-danger py-1">ทั้งหมด {{this.value}} ชิ้น | {{format_price(this.value * this.prod.price.marginPrice)}} <small>¥</small></h1>
                        <h1 v-if="this.prod.listOfProp.length == 0 && this.prod.quantityRange.length > 1" class="font-weight-bolder text-danger py-1">ทั้งหมด {{this.value}} ชิ้น | {{format_price(this.value * this.prod.quantityRange.filter(x => x.minQuantity <= this.value)[this.prod.quantityRange.filter(x => x.minQuantity <= this.value).length - 1].price.marginPrice)}} <small>¥</small></h1>
                      </b-col>
                    </b-row>
                  </div>
                  <!-- ปุ่มเพิ่มสินค้าเข้าออเดอร์ -->
                  <div class="pt-2">
                    <b-row>
                      <!-- 1688 -->
                      <b-col v-if="checkShop.product1688" class="d-md-flex align-items-center">
                        <b-button
                          v-if="this.prod.listOfProp.length != 0"
                          variant="danger"
                          @click="addProduct1688()"
                          :disabled="this.quantityProd.map(i => parseInt(i.quantityInput)).reduce((a, b) => a + b) < this.prod.minimumQuantity || loadButton == false"
                        >
                          <b-spinner v-if="loadButton == false" small />
                          เพิ่มสินค้า
                        </b-button>
                        <b-button
                          v-if="this.prod.listOfProp.length == 0"
                          variant="danger"
                          @click="addProduct1688Prop0()"
                          :disabled="this.value < this.prod.minimumQuantity || loadButton == false"
                        >
                          <b-spinner v-if="loadButton == false" small />
                          เพิ่มสินค้า
                        </b-button>
                        <div v-if="this.orderStatus != ''" class="pl-md-1">
                          <b-img :src="require('@/assets/Correct.png')"></b-img>
                          <span style="color:green">เพิ่มสินค้าเข้าออเดอร์เรียบร้อย</span>
                          <br>
                        </div>
                      </b-col>
                      <!-- taobao -->
                      <b-col v-if="checkShop.product" class="d-md-flex align-items-center">
                        <b-button
                          variant="danger"
                          @click="addProductTaobao()"
                          :disabled="this.checkQuanAndButton == false || this.quanOfProp == 0 || loadButton == false"
                        >
                          <b-spinner v-if="loadButton == false" small />
                          เพิ่มสินค้า
                        </b-button>
                        <div v-if="this.orderStatus != ''" class="pl-md-1">
                          <b-img :src="require('@/assets/Correct.png')"></b-img>
                          <span style="color:green">เพิ่มสินค้าเข้าออเดอร์เรียบร้อย</span>
                          <br>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>
            </div>
            <!-- <div class="text-right">
              <b-button variant="outline-secondary" @click="closeModal()">ยกเลิก</b-button>
              <b-button class="ml-1" variant="primary">เพิ่มสินค้า</b-button>
            </div> -->
          </b-tab>
          <b-tab title="เลือกแบบเก่า">
            <b-form>
              <b-row class="pl-md-2 px-xs-0">
                <b-col cols="12" md="9">
                  <b-form-group label="ลิ้งค์สินค้า :" label-cols-md="4">
                      <div class="d-flex align-items-center">
                        <b-form-input class="col-md-10 col-xs-12" v-model="urlAdd"/>
                        <span v-if="this.validateUrlAdd == false" class="pl-2 text-danger">กรุณาระบุ</span>
                      </div>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="9">
                  <b-form-group label="ร้านที่ :" label-cols-md="4">
                    <b-form-spinbutton v-model="shopAdd" class="mb-md-0 mb-2 col-md-10" min="1" max="100">
                      <template #increment>
                        <feather-icon icon="ChevronUpIcon" />
                      </template>
                      <template #decrement>
                        <feather-icon icon="ChevronDownIcon" />
                      </template>
                    </b-form-spinbutton>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="9">
                  <b-form-group label="ไซส์ :" label-cols-md="4">
                    <b-form-input class="col-md-10 col-xs-12" v-model="sizeAdd"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="9">
                  <b-form-group label="สี :" label-cols-md="4">
                    <b-form-input class="col-md-10 col-xs-12" v-model="colorAdd"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="9">
                  <b-form-group label="จำนวน :" label-cols-md="4">
                    <cleave
                      v-model="amountAdd"
                      class="form-control col-md-10"
                      :raw="false"
                      :options="optionsAdd.amountAdd"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="9">
                  <b-form-group label="ราคา(หยวน) :" label-cols-md="4">
                    <div class="d-flex align-items-center">
                      <cleave
                        v-model="yuanAdd"
                        class="form-control col-md-10"
                        :raw="false"
                        :options="optionsAdd.yuanAdd"
                      />
                      <span v-if="this.validateYuanAdd == false" class="pl-2 text-danger">กรุณาระบุ</span>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="9">
                  <b-form-group label="รายละเอียดเพิ่มเติม :" label-cols-md="4" >
                    <b-form-textarea class="col-md-10 col-xs-12" v-model="remarkAdd" placeholder="รายละเอียดเพิ่มเติม เช่น ลิ้งค์สำรอง สีหรือไซส์สำรอง" rows="3"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="9">
                  <b-form-group label="รูปภาพ :" label-cols-md="4">
                    <b-form-file class="col-md-10 col-xs-12" v-model="pic64Add" placeholder="Choose a file" drop-placeholder="Drop file here..."/>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <!-- submit and reset -->
              <b-row class="pl-md-2">
                <b-col  class="d-md-flex">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mr-1"
                    @click="addProduct()"
                    :disabled="this.loadButtonAdd == false"
                  >
                    <b-spinner v-if="this.loadButtonAdd == false" small />
                    เพิ่มเข้าตะกร้า
                  </b-button>
                  <div v-if="this.orderAddStatus" class="pl-md-1">
                    <b-img :src="require('@/assets/Correct.png')"></b-img>
                    <span style="color:green">เพิ่มสินค้าเข้าตะกร้าเรียบร้อย</span>
                    <br>
                    <span>(ดูสินค้าในตะกร้าได้ที่รูปรถเข็นมุมขวาบน)</span>
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>

    <b-modal ref="show-img" size="lg" hide-footer centered>
      <b-img class="px-0" :src="this.imgLink" fluid ></b-img>
    </b-modal>

    <!-- error -->
    <b-card v-if="this.checkStatus == 'error' && this.loadpage == false">
      <h1>{{this.checkMessage}}</h1>
      <!-- <h1>อาจเกิดปัญหาระหว่างการส่งออเดอร์ กรุณาลองส่งออเดอร์ใหม่อีกครั้งค่ะ</h1> -->
    </b-card>

    <div v-if="this.checkStatus == 'success'">
      <div class="footer" v-if="this.orderDetail.statusID == 0">
        <b-card class="my-0" no-body>
          <b-card-body class="px-0">
            <b-button variant="primary" @click="sendToCheck">บันทึก และ ส่งออเดอร์ให้ตรวจสอบ</b-button>
          </b-card-body>
        </b-card>
      </div>
    </div>

  </div>
</template>

<script>
import {
  BCard, BTable, BFormGroup, BButton, BCardHeader, BCardBody, BRow, BCol, BTabs, BTab, BSpinner, BImg,
  BModal, BContainer, BCollapse, VBToggle, VBModal, BFormRadioGroup, BForm, BFormRadio, BTooltip,BLink,
  BFormTextarea, BInputGroup, BFormInput, BInputGroupPrepend, BInputGroupAppend, BFormCheckbox,
  BFormSpinbutton, BFormFile

  // BTab,
  // BFormSpinbutton, BFormFile, BOverlay, BCardText, BDropdown, BDropdownItem,
  // BFormCheckboxGroup, BAlert, BButtonGroup,

} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { format_price } from '@/views/global_function.js'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
    'b-modal': VBModal,
  },

  components: {
    BCard, BTable, BFormGroup, BButton, BCardHeader, BCardBody, BRow, BCol,  BTabs, BTab, BSpinner,BImg,
    BModal, BContainer, BCollapse, VBToggle, BFormRadioGroup, BForm, BFormRadio, BTooltip, BFormTextarea, BLink,
    BInputGroup, BFormInput, BInputGroupPrepend, BInputGroupAppend, VBModal, BFormCheckbox, vSelect,
    BFormSpinbutton, BFormFile,
    // input
    Cleave,
    //timline
    AppTimeline, AppTimelineItem,
    //view img
    Swiper, SwiperSlide
  },
  data() {
    return {
      orderId: null,
      orderDetail: [],
      checkType: '',
      checkMessage: '',
      loadpage: true,

      trackStatusList: [],
      imgLink: '',
      token: JSON.parse(localStorage.getItem('userData')),
      // admin-branch: identity ของลูกค้าเจ้าของ order (มาจาก query param ไม่ใช่ session ของ admin)
      customerToken: null,
      customerId: null,
      // แก้ไขสถานะออเดอร์
      editingStatus: false,
      statusOptions: [],
      selectedStatus: null,
      savingStatus: false,
      stateMents: [],
      stateMentsFields:[
        { key: 'description' },
        { key: 'amount', tdClass: 'text-right'},
        { key: 'unit', tdClass: 'text-right'},
      ],
      checkStatus: null,

      orderItemsFields: [
        { key: 'no', label: 'ลำดับ', thClass: 'text-center px-0', tdClass: 'text-center px-0'},
        { key: 'photoLink', label: 'รูป', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'title', label: 'สินค้า' },
        { key: 'quantityReviewed', label: 'จำนวนสั่งครั้งแรก', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'quantityOrdered', label: 'จำนวนที่สั่งได้', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'quantityReceived', label: 'จำนวนที่ได้รับ', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'priceReceived', label: 'ราคา/ชิ้น(¥)', thClass: 'text-center', tdClass: 'text-right'},
        { key: 'totalPriceReceived', label: 'ราคารวม(¥)', thClass: 'text-center', tdClass: 'text-right'},
        { key: 'retailPrice', label: 'ค่านำเข้า/ชิ้น(฿)', thClass:'text-center', tdClass: 'text-right'},
        { key: 'totalPriceReceivedBaht', label: 'ราคารวม(฿)', thClass: 'text-center', tdClass: 'text-right'},
        { key: 'remarkCustomer', label: 'หมายเหตุ'},
        { key: 'remarkAdmin', label: 'หมายเหตุ(จากทางร้าน)'},
        { key: 'itemID', label: 'ตัวเลือก', thClass: 'text-center', tdClass: 'text-center'},
      ],
      orderItemsFieldsMobile: [
        { key: 'quantityReviewed', label: 'จำนวนสั่งครั้งแรก', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'quantityOrdered', label: 'จำนวนที่สั่งได้', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'quantityReceived', label: 'จำนวนที่ได้รับ', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'priceReceived', label: 'ราคา/ชิ้น(¥)', thClass: 'text-center', tdClass: 'text-right'},
        { key: 'totalPriceReceived', label: 'ราคารวม(¥)', thClass: 'text-center', tdClass: 'text-right'},
        { key: 'totalPriceReceivedBaht', label: 'ราคารวม(฿)', thClass: 'text-center', tdClass: 'text-right'},
      ],

      transportId: null,
      transportList:[],
      domesticsId:null,
      domesticsList: [],
      otherDomestics: '',
      customerAddressId: null,
      customerAdressList: [],
      senderAddressId: null,
      senderAddressList:[],
      checkSender: false,
      valDomestics: true,
      valOther: true,
      valCustomer: true,
      valSender: true,

      itemId: null,
      inputQuantity: 0,
      quantity: 1,
      priceOrder: 0,
      options: {
        priceOrder: {
          numeral: true,
          numeralPositiveOnly: true
        },
      },
      color: '',
      size: '',
      otherOption: '',
      remarkOrder: '',
      valQuantity: true,
      valPrice: true,

      //srch product
      tabIndex: 0,
      linkItem: '',
      valLink: true,
      loadProduct: false,

      value: 0,
      valueProp1: [],
      valueTaobao: 1,
      // url: '',
      // urlError: '',
      fields: [
        {id: 1 , label: 'ราคา'},
        {id: 2 , label: 'จำนวน'},
        {id: 3 , label: 'เลือก'},
      ],

      swiperOptions: {
        loop: true,
        loopedSlides: 5,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 4,
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
      imgList: [],
      srchStatus: null,
      checkLoadOrder: null,

      //call api
      prod: [],
      quantityProd: [],
      quantityRange: [],
      // loadpage: false,
      prop1:'',
      prop2:'',
      prop3:'',
      propPath: '',
      quanOfProp: 0,
      price:0,          //dupe
      totalPrice:0,
      checkShop: '',
      prop1Value: '',
      prop2Value: '',
      prop3Value: '',
      remark: '',
      // taobao
      maxPrice: '',
      minPrice: '',
      priceMinMax: '',
      imageIcon: '',
      productImg: '',
      checkQuanAndButton: false,
      prop1TextTaobao: '',
      prop2TextTaobao: '',
      prop3TextTaobao: '',
      pricePerItem: null,
      checkStock: [],
      checkStock1: [],
      checkStock2: [],
      checkStock3: [],

      //
      prop1ID: '',
      yuanPriceFromQuantityRange: null,
      bInputGroup: '',
      permission: '',

      //add success
      orderStatus: '',
      loadButton: true,

      // add manual
      valueAdd: 1,
      urlAdd: '',
      shopAdd: 1,
      sizeAdd: null,
      colorAdd: null,
      amountAdd: 1,
      yuanAdd: null,
      remarkAdd: null,
      pic64Add: null,

      optionsAdd: {
        yuanAdd: {
          numeral: true,
          numeralPositiveOnly: true
        },
        amountAdd: {
          numeral: true,
          numeralPositiveOnly: true
        },
      },
      orderAddStatus: '',
      validateUrlAdd: true,
      validateYuanAdd: true,
      loadButtonAdd: true,
    };
  },

  created() {
    this.getOrderDetail()
    this.getStatusList()
  },

  computed: {
    totalYuanPrice() {
      var price = 0
      if (this.yuanPriceFromQuantityRange != null) {
        this.quantityProd.forEach((e) => {
          price += this.yuanPriceFromQuantityRange * e.quantityInput
        })
      }
      else{
        this.quantityProd.forEach((e) => {
          price += e.price * e.quantityInput
        })
      }
      return format_price(price)
    },
    groups(){
      return this.groupBy(this.quantityProd, 'prop1ID')
    }
  },

  watch: {
    bInputGroup() {
      if (this.quantityProd.length != 0) {
        var totalQuantity = this.quantityProd.map(i => parseInt(i.quantityInput)).reduce((a, b) => a + b)
        this.prod.quantityRange.forEach((element) => {
          if (totalQuantity >= element.minQuantity && totalQuantity <= element.maxQuantity) {
            this.yuanPriceFromQuantityRange = element.price.marginPrice
          } else if (totalQuantity >= element.minQuantity && element.maxQuantity == 0) {
            this.yuanPriceFromQuantityRange = element.price.marginPrice
          }
        })
      }
    },

    //add manual
    yuanAdd() {
      if (this.yuanAdd != null && this.yuanAdd != 0 && this.yuanAdd != '') {
        this.validateYuanAdd = true
      }
    },
    urlAdd() {
      if (this.urlAdd != '') {
        this.validateUrlAdd = true
        this.orderAddStatus = ''
      }
    }
  },

  methods: {
    format_price,
    b64decode(raw) {
      // param จาก order-status ถูกเข้ารหัส base64 -> ถอดรหัส (เผื่อค่าดิบก็ fallback)
      if (!raw) return raw
      try {
        return atob(raw)
      } catch (e) {
        return raw
      }
    },
    async getStatusList() {
      try {
        const res = await axios.post(
          taobaoService_dotnet + 'app/Branch/get-order-status-list',
          {},
          { headers: header_token }
        )
        this.statusOptions = res.data.items || []
      } catch (e) {
        console.log(e)
      }
    },
    startEditStatus() {
      // ตั้ง dropdown เป็นสถานะปัจจุบัน
      this.selectedStatus = this.statusOptions.find(s => s.statusID === this.orderDetail.statusID) || null
      this.editingStatus = true
    },
    cancelEditStatus() {
      this.editingStatus = false
      this.selectedStatus = null
    },
    async saveStatus() {
      if (!this.selectedStatus) return
      this.savingStatus = true
      try {
        const res = await axios.post(
          taobaoService_dotnet + 'app/Branch/update-order-status',
          {
            orderID: parseInt(this.orderId),
            statusID: this.selectedStatus.statusID,
            branchID: this.token && this.token.data ? this.token.data.branchID : null,
          },
          { headers: header_token }
        )
        if (res.data === 'success') {
          this.editingStatus = false
          this.selectedStatus = null
          this.$bvToast.toast('อัปเดตสถานะออเดอร์เรียบร้อย', {
            title: 'สำเร็จ', variant: 'success', solid: true, toaster: 'b-toaster-top-right',
          })
          await this.getOrderDetail()
        } else {
          this.$bvToast.toast(typeof res.data === 'string' ? res.data : 'อัปเดตสถานะไม่สำเร็จ', {
            title: 'ไม่สำเร็จ', variant: 'warning', solid: true, toaster: 'b-toaster-top-right',
          })
        }
      } catch (e) {
        console.log(e)
        this.$bvToast.toast('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', {
          title: 'ผิดพลาด', variant: 'danger', solid: true, toaster: 'b-toaster-top-right',
        })
      } finally {
        this.savingStatus = false
      }
    },
    async getOrderDetail(){
      this.loadpage = true
      localStorage.removeItem("tokenAuto");
      localStorage.removeItem("orderidAuto");
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      // admin-branch: orderid/token/cusId ถูกเข้ารหัส base64 -> ถอดรหัสก่อนใช้
      const orderid = this.b64decode(urlParams.get('orderid'))
      const token = this.b64decode(urlParams.get('token'))
      const cusId = this.b64decode(urlParams.get('cusId'))
      // เก็บ identity ของลูกค้าเจ้าของ order ไว้ใช้ทุกที่ (แทน session ของ admin)
      this.customerToken = token || null
      this.customerId = cusId ? JSON.parse(cusId) : null
      this.orderId = orderid
      var keepdata = []
      var axios = require('axios');
      var data = JSON.stringify({
        "orderID": parseInt(orderid),
        "customerToken": this.customerToken,
      });

      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/order/detail/load-view-order-detail-page-v3',
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U',
          'Content-Type': 'application/json'
        },
        data : data
      };

      await axios(config)
      .then(function (response) {
        keepdata = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      this.orderDetail = keepdata.data
      this.checkStatus = keepdata.status
      this.checkMessage = keepdata.message
      this.checkType = await orderid.slice(0, 1)
      if (this.checkType == '1') {
        this.orderItemsFields[8].thClass = 'text-center'
        this.orderItemsFields[8].tdClass = 'text-right'
      } else {
        this.orderItemsFields[8].thClass = 'text-center d-none'
        this.orderItemsFields[8].tdClass = 'text-right d-none'
      }
      if (keepdata.status == 'success') {
        this.stateMents = keepdata.data.statements
        this.orderDetail.supplier.forEach((e) => {
          e.trackStatuses.forEach((i) => {
            if (i.arrivedThaiDate) {
              this.trackStatusList.push({
                'track': i.trackingNo,
                'status': 'ถึงไทยวันที่',
                'date': i.arrivedThaiDate
              })
            } else if (i.expectedArrival) {
              this.trackStatusList.push({
                'track': i.trackingNo,
                'status': 'ประมาณการถึงไทย',
                'date': i.expectedArrival
              })
            } else if (i.offChinaDate) {
              this.trackStatusList.push({
                'track': i.trackingNo,
                'status': 'ออกจากจีน',
                'date': i.offChinaDate
              })
            } else if (i.receiveDate) {
              this.trackStatusList.push({
                'track': i.trackingNo,
                'status': 'เข้าโกดังจีน',
                'date': i.receiveDate
              })
            } else if (i.shipDate) {
              this.trackStatusList.push({
                'track': i.trackingNo,
                'status': 'ร้านค้าส่งออก',
                'date': i.shipDate
              })
            }
          })
        })
      }
      this.loadpage = false
      if (keepdata.status == 'success') {
        if ( this.checkType == '1' && this.orderDetail.statusID <= 3) {
          this.getCustomerAddress()
          this.getSenderAddress()
          this.getDomestics()
        }
        if (this.orderDetail.statusID <= 3) {
          this.getTransportType()
        }
      }
    },
    async showImg(img) {
      this.imgLink = await img
      this.$refs['show-img'].show()
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.isHighlight == true) return 'table-success'
    },
    rowColor(item, type) {
      if (!item || type !== 'row') return
      if (item.backcolor == 'success ') return 'table-success'
      if (item.backcolor == 'danger') return 'table-danger'
    },
    async getTransportType() {
      this.transportId = null
      let response = await axios.get(
        taobaoService_dotnet + '/app/order/get-transport-type' ,
        { headers: header_token }
      );
      this.transportList = response.data
      response.data.forEach((e) => {
        if (e.descriptionTH == this.orderDetail.transportType) {
          this.transportId = e.id
        }
      })
    },
    async getDomestics() {
      this.domesticsId = null
      this.otherDomestics = ''
      let response = await axios.get(
        taobaoService_dotnet + 'api/General/get-express' ,
        { headers: header_token }
      );
      this.domesticsList = response.data
      response.data.forEach((e) => {
        if (e.description == this.orderDetail.expressCompanyName) {
          this.domesticsId = e
        }
      })
      if (this.domesticsId == null) {
        if (this.orderDetail.expressCompanyName) {
          this.domesticsId = {
            description: 'ขนส่งอื่นๆ',
            rowId: 11
          }
          this.otherDomestics = this.orderDetail.expressCompanyName
        } else {
          this.domesticsId = {
            description: '-- ยังไม่ได้เลือกขนส่ง --',
            rowId: null
          }
        }
      }
    },
    async getCustomerAddress(){
      this.customerAddressId = null
      this.customerAdressList = []
      let response = await axios.post(
        taobaoService_dotnet + 'app/Customer/get-customer-address',
        {
          "loginToken": this.customerToken,
          "isReceiver": true
        },
        { headers: header_token }
      );
      await response.data.forEach(async (e) => {
        this.customerAdressList.push({
          addressID: e.addressID,
          address: e.name + ' โทร: ' + e.phone + ' ' + e.address + ' ต.' + e.tambon + ' อ.' + e.amphoe + ' จ.' + e.province + ' ' + e.postcode
        })
        var address = await e.name + ' โทร: ' + e.phone + ' ' + e.address + ' ต.' + e.tambon + ' อ.' + e.amphoe + ' จ.' + e.province + ' ' + e.postcode
        if (address == this.orderDetail.receiveAddress) {
          this.customerAddressId = {
            addressID: e.addressID,
            address: e.name + ' โทร: ' + e.phone + ' ' + e.address + ' ต.' + e.tambon + ' อ.' + e.amphoe + ' จ.' + e.province + ' ' + e.postcode
          }
        }
      })
      if (this.customerAddressId == null) {
        this.customerAddressId = {
          addressID: null,
          address: '-- ยังไม่ได้เลือกที่อยู่จัดส่ง --'
        }
      }
    },
    async getSenderAddress(){
      this.senderAddressId = null
      this.senderAddressList = []
      this.checkSender = false
      let response = await axios.post(
        taobaoService_dotnet + 'app/Customer/get-customer-address',
        {
          "loginToken": this.customerToken,
          "isReceiver": false
        },
        { headers: header_token }
      );
      await response.data.forEach(async (e) => {
        this.senderAddressList.push({
          addressID: e.addressID,
          address: e.name + ' โทร: ' + e.phone + ' ' + e.address + ' ต.' + e.tambon + ' อ.' + e.amphoe + ' จ.' + e.province + ' ' + e.postcode
        })
        var address = await e.name + ' โทร: ' + e.phone + ' ' + e.address + ' ต.' + e.tambon + ' อ.' + e.amphoe + ' จ.' + e.province + ' ' + e.postcode
        if (address == this.orderDetail.senderAddress) {
          this.senderAddressId = {
            addressID: e.addressID,
            address: e.name + ' โทร: ' + e.phone + ' ' + e.address + ' ต.' + e.tambon + ' อ.' + e.amphoe + ' จ.' + e.province + ' ' + e.postcode
          }
        }
      })
      if (this.senderAddressId == null) {
        this.senderAddressId = {
          addressID: null,
          address: '-- ยังไม่ได้เลือกที่อยู่จัดส่งในนาม --'
        }
      }
    },
    async editOrder() {
      if (this.checkType == '1' && this.domesticsId.rowId == null) {
        this.valDomestics = false
        document.getElementById('domestics').scrollIntoView();
      } else if ( this.checkType == '1' && this.domesticsId.rowId == 11 && this.otherDomestics == '') {
        this.valOther = false
        document.getElementById('domestics').scrollIntoView();
      } else if ( this.checkType == '1' && this.customerAddressId.addressID == null ){
        this.valCustomer = false
        document.getElementById('cus-address').scrollIntoView();
      } else if ( this.checkType == '1' && this.senderAddressId.addressID == null && this.checkSender == true ){
        this.valSender = false
        document.getElementById('sender-address').scrollIntoView();
      }
      else {
        if (this.checkType == '1') {
          var domestics = ''
          if ( await this.domesticsId.rowId == 11) {
            domestics = await this.otherDomestics
          } else {
            domestics = await this.domesticsList.filter(x => x.rowId == this.domesticsId.rowId)[0].description
          }
        }
        let response = await axios.post(
          taobaoService_dotnet + 'app/order/detail/edit-order-info',
          {
            "orderID": this.orderDetail.orderID,
            "transportType": this.transportId,
            "expressCompanyID": this.checkType == '1' ? this.domesticsId.rowId : null,
            "expressCompanyName": this.checkType == '1' ? domestics : null,
            "receiverAddressID": this.checkType == '1' ? this.customerAddressId.addressID : null,
            "senderAddressID": this.checkType == '1' && this.checkSender == true ? this.senderAddressId.addressID : null
          },
          { headers: header_token }
        );
        if ( response.data.status == 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'แก้ไขข้อมูลออเดอร์เรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          this.getOrderDetail()
          this.$refs['edit'].hide()
        }
      }
    },
    async editItem() {
      if (this.quantity == '' || this.quantity == '0' || this.quantity == 0) {
        this.valQuantity = false
      } else if (this.priceOrder == '' || this.priceOrder == '0') {
        this.valPrice = false
      } else {
        let response = await axios.post(
          taobaoService_dotnet + 'app/order/detail/update-order-item-v2',
          {
            "itemID": this.itemId,
            "quantity": parseInt(this.quantity),
            "remark": this.remarkOrder,
            "prop1": this.color,
            "prop2": this.size,
            "prop3": this.otherOption,
            "price": Number(this.priceOrder)
          },
          { headers: header_token }
        );
        if (response.data == 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'แก้ไขข้อมูลสินค้าเรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          this.getOrderDetail()
          this.$refs['edit-item'].hide()
        }
      }
    },
    async deleteItem (id, title) {
      this.$swal({
        title: 'ต้องการลบสินค้า?',
        text: 'สินค้า : ' + title,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          let response = await axios.post(
            taobaoService_dotnet + 'app/order/detail/delete-order-item',
            { "itemID": id },
            { headers: header_token }
          );
          if (response.data == 'success') {
            this.getOrderDetail()
          }
        }
      })
    },
    async sendToCheck() {
      this.$swal({
        title: 'ส่งออเดอร์เพื่อตรวจสอบ?',
        text: 'ต้องการส่งออเดอร์ : ' + this.orderDetail.orderID + ' เพื่อตรวจสอบ?',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          let response = await axios.post(
            taobaoService_dotnet + 'app/order/detail/send-order-to-check',
            { "orderID": this.orderDetail.orderID },
            { headers: header_token }
          );
          if (response.data == 'success') {
            this.getOrderDetail()
          }
        }
      })
    },
    closeModalEdit() {
      this.$refs['edit'].hide()
      if ( this.checkType == '1' && this.orderDetail.statusID <= 3) {
        this.getCustomerAddress()
        this.getSenderAddress()
        this.getDomestics()
      }
      if (this.orderDetail.statusID <= 3) {
        this.getTransportType()
      }
      this.valOther = true
      this.valCustomer = true
      this.valSender = true
    },
    closeModal() {
      this.$refs['edit-item'].hide()
    },
    openEditItemModal(id) {
      this.itemId = id
      this.valQuantity = true
      this.valPrice = true
      this.orderDetail.supplier.forEach((e) => {
        e.orderItems.forEach((i) => {
          if ( i.itemID == id ) {
            this.quantity = i.quantityReviewed
            this.priceOrder = i.priceReviewed
            this.color = i.color
            this.size = i.size
            this.otherOption = i.otherOption == null ? '' : i.otherOption
            this.remarkOrder = i.remarkCustomer
            return
          }
        })
      })
      this.$refs['edit-item'].show()
    },
    async openSearchModal() {
      this.$refs['add-item'].show()
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.$swiper
        const swiperThumbs = this.$refs.swiperThumbs.$swiper
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
      })
    },
    closeAddItem() {
      if (this.checkLoadOrder) {
        this.getOrderDetail()
      }
      this.$refs['add-item'].hide()
      this.imgList = []
      this.orderStatus = ''
      this.prod = []
      this.imageIcon = ''
      this.productImg= ''
      this.quantityProd = []
      this.quanOfProp = 0
      this.remark = ''
      this.srchStatus = null
      this.checkLoadOrder = null
      //1688
      this.quantityRange = []
      this.price = 0
      this.value = 0
      this.yuanPriceFromQuantityRange = null

      //taobao
      this.prop1 = ''
      this.prop2 = ''
      this.pricePerItem = null
      this.priceMinMax = ''
      this.prop1Value = ''
      this.prop2Value = ''
      this.propPath = ''
      this.valueTaobao = 1
      this.checkStock = []
      this.checkStock1 = []
      this.checkStock2 = []
      this.valueTaobao = 1
      this.checkQuanAndButton = false

      // add manual
      this.pic64Add = null
      this.yuanAdd = null
      this.urlAdd = ''
      this.sizeAdd = null
      this.colorAdd = null
      this.amountAdd = 1
      this.remarkAdd = null
      this.shopAdd = 1
      this.orderAddStatus = ''
    },

    //add product
    async searchProduct() {
      if (this.linkItem == '') {
        this.valLink = false
      } else {
        this.imgList = []
        this.orderStatus = ''
        this.prod = []
        this.imageIcon = ''
        this.productImg= ''
        this.quantityProd = []
        this.quanOfProp = 0
        this.remark = ''
        this.srchStatus = null
        this.checkLoadOrder = null
        //1688
        this.quantityRange = []
        this.price = 0
        this.value = 0
        this.yuanPriceFromQuantityRange = null

        //taobao
        this.prop1 = ''
        this.prop2 = ''
        this.prop3 = ''
        this.pricePerItem = null
        this.priceMinMax = ''
        this.prop1Value = ''
        this.prop2Value = ''
        this.prop3Value = ''
        this.prop1TextTaobao = ''
        this.prop2TextTaobao = ''
        this.prop3TextTaobao = ''
        this.propPath = ''
        this.valueTaobao = 1
        this.checkStock = []
        this.checkStock1 = []
        this.checkStock2 = []
        this.checkStock3 = []
        this.valueTaobao = 1
        this.checkQuanAndButton = false

        // add manual
        this.pic64Add = null
        this.yuanAdd = null
        this.urlAdd = ''
        this.sizeAdd = null
        this.colorAdd = null
        this.amountAdd = 1
        this.remarkAdd = null
        this.shopAdd = 1
        this.orderAddStatus = ''

        // this.checkShop = ''
        this.tabIndex = 0
        this.loadProduct = await true
        let response = await axios.post(
          taobaoService_dotnet + 'app/add-product/search-product',
          {
            "customerID": this.customerId,
            "productLink": this.linkItem,
          },
          { headers: header_token }
        );

        this.linkItem = response.data.link
        this.srchStatus = response.data.status
        if (response.data.status == true) {
          if (response.data.product1688) {
            this.prod = await response.data.product1688
            this.quantityProd = await response.data.product1688.propItemCombination1688
            if (response.data.product1688.propItemCombination1688.length != 0) {
              this.quanOfProp = await response.data.product1688.propItemCombination1688[0].quantity
            }
            this.quantityRange = await response.data.product1688.quantityRange
            this.price = await response.data.product1688.price.marginPrice
            this.checkShop = await response.data
            this.value = await response.data.product1688.minimumQuantity
            if (this.prod.listOfProp.length == 2) {
              this.prop1ID = this.prod.listOfProp[0].listOfPropItem[0].propPath
            }
            this.imgList = this.prod.listOfMainImage
            this.loadProduct = await false
          } else if(response.data.product){
            this.prod = await response.data.product
            this.quantityProd = await response.data.product.listOfSKUBase

            if ( response.data.product.listOfProp.length > 0 ) {
              var stockProp2 = []
              this.quantityProd.forEach((e) => {
                this.prod.listOfProp[0].listOfPropItem.forEach((i) => {
                  if (e.propPath.includes(i.propPath) == true) {
                    stockProp2.push({
                      'path': i.propPath,
                      'prop': i.name,
                      'quantity': e.quantity
                    })
                  }
                })
              })
              var uniqProp2 = [];
              var uniqFormatProp2 = [];
              var dupeProp2 = [];
              var dupeFormatProp2 = [];
              stockProp2.forEach(obj => [uniqProp2,dupeProp2][+(stockProp2.map(obj => obj.path).filter(path =>path === obj.path).length > 1)].push(obj));
              uniqFormatProp2 = uniqProp2.filter( x => x.quantity != 0)
              dupeFormatProp2 = [...new Map((dupeProp2.filter( x => x.quantity != 0)).map(item => [JSON.stringify(item.path), item])).values()]
              dupeFormatProp2.forEach((e) => {
                this.checkStock2.push(e)
              })
              uniqProp2.forEach((e) => {
                this.checkStock2.push(e)
              })
            }
            if ( response.data.product.listOfProp.length >= 2 ) {
              var stockProp1 = []
              this.quantityProd.forEach((e) => {
                this.prod.listOfProp[1].listOfPropItem.forEach((i) => {
                  if (e.propPath.includes(i.propPath) == true) {
                    stockProp1.push({
                      'path': i.propPath,
                      'prop': i.name,
                      'quantity': e.quantity
                    })
                  }
                })
              })
              var uniqProp1 = [];
              var uniqFormatProp1 = [];
              var dupeProp1 = [];
              var dupeFormatProp1 = [];
              stockProp1.forEach(obj => [uniqProp1,dupeProp1][+(stockProp1.map(obj => obj.path).filter(path =>path === obj.path).length > 1)].push(obj));
              uniqFormatProp1 = uniqProp1.filter( x => x.quantity != 0)
              dupeFormatProp1 = [...new Map((dupeProp1.filter( x => x.quantity != 0)).map(item => [JSON.stringify(item.path), item])).values()]
              dupeFormatProp1.forEach((e) => {
                this.checkStock1.push(e)
              })
              uniqProp1.forEach((e) => {
                this.checkStock1.push(e)
              })

              if (response.data.product.listOfProp.length == 3) {
                var stockProp3 = []
                this.quantityProd.forEach((e) => {
                  this.prod.listOfProp[2].listOfPropItem.forEach((i) => {
                    if (e.propPath.includes(i.propPath) == true) {
                      stockProp3.push({
                        'path': i.propPath,
                        'prop': i.name,
                        'quantity': e.quantity
                      })
                    }
                  })
                })
                var uniqProp3 = [];
                var uniqFormatProp3 = [];
                var dupeProp3 = [];
                var dupeFormatProp3 = [];
                stockProp3.forEach(
                  obj => [uniqProp3,dupeProp3][+(stockProp3.map(obj => obj.path).filter(path =>path === obj.path).length > 1)].push(obj)
                );
                uniqFormatProp3 = uniqProp1.filter( x => x.quantity != 0)
                dupeFormatProp3 = [...new Map((dupeProp3.filter( x => x.quantity != 0)).map(item => [JSON.stringify(item.path), item])).values()]
                dupeFormatProp3.forEach((e) => {
                  this.checkStock3.push(e)
                })
                uniqProp3.forEach((e) => {
                  this.checkStock3.push(e)
                })

              }
            }

            if (response.data.product.minPrice != response.data.product.maxPrice) {
              this.priceMinMax = await response.data.product.minPrice + " - " + response.data.product.maxPrice
              var quan = await response.data.product.listOfSKUBase.filter(x => x.propPath != "" && x.quantity != 0)
              if (quan.length == 1) {
                this.priceMinMax = quan[0].price
              }
            } else if (response.data.product.minPrice == response.data.product.maxPrice) {
              this.priceMinMax = await response.data.product.maxPrice
            }
            if (response.data.product.listOfSKUBase.length != 0 && response.data.product.listOfProp != 0) {
              var skuList = await response.data.product.listOfSKUBase.filter( x => x.quantity != 0)
              var propItemList = []
              response.data.product.listOfProp[0].listOfPropItem.forEach((e) => {
                skuList.forEach((i) => {
                  if(e.propPath == i.propPath){
                    propItemList.push(e)
                  }
                })
              })
            }
            if (response.data.product.listOfProp.length == 0) {
              this.quanOfProp = response.data.product.listOfSKUBase[0].quantity
              this.checkQuanAndButton = true
            } else if ((response.data.product.listOfProp[0].listOfPropItem.length == 1 || propItemList.length == 1) && (response.data.product.listOfSKUBase.length == 2 || skuList.length == 2) && (response.data.product.listOfProp.length == 1 || response.data.product.listOfProp[1].listOfPropItem.length == 1)) {
              this.quanOfProp = response.data.product.listOfSKUBase[0].quantity
              this.checkQuanAndButton = true
            }
            if ( response.data.product.listOfProp.length > 0 ) {
              this.prop2 = await response.data.product.listOfProp[0].listOfPropItem.length == 1 ? response.data.product.listOfProp[0].listOfPropItem[0].propPath : ''
              this.prop1Value = await response.data.product.listOfProp[0].listOfPropItem.length == 1 ? response.data.product.listOfProp[0].listOfPropItem[0].name : ''
              if (this.checkStock2.length != 0 && this.prop2 == '') {
                if (this.checkStock2.filter(x => x.quantity != 0).length == 1) {
                  var path2 = await this.checkStock2.filter(x => x.quantity != 0)[0].path
                  this.prop2 = response.data.product.listOfProp[0].listOfPropItem.filter( x => path2 == x.propPath)[0].propPath
                  this.prop1Value = response.data.product.listOfProp[0].listOfPropItem.filter( x => path2 == x.propPath)[0].name
                }
              }
            }
            if ( response.data.product.listOfProp.length >= 2 ) {
              this.prop1 =  await response.data.product.listOfProp[1].listOfPropItem.length == 1 ? response.data.product.listOfProp[1].listOfPropItem[0].propPath : ''
              this.prop2Value = await response.data.product.listOfProp[1].listOfPropItem.length == 1 ? response.data.product.listOfProp[1].listOfPropItem[0].name : ''
              if (this.checkStock1.length != 0 && this.prop1 == '') {
                if (this.checkStock1.filter(x => x.quantity != 0).length == 1) {
                  var path1 = await this.checkStock1.filter(x => x.quantity != 0)[0].path
                  this.prop1 = response.data.product.listOfProp[1].listOfPropItem.filter( x => path1 == x.propPath)[0].propPath
                  this.prop2Value = response.data.product.listOfProp[1].listOfPropItem.filter( x => path1 == x.propPath)[0].name
                }
              }

              if (response.data.product.listOfProp.length == 3) {
                this.prop3 =  await response.data.product.listOfProp[2].listOfPropItem.length == 1 ? response.data.product.listOfProp[2].listOfPropItem[0].propPath : ''
                this.prop3Value = await response.data.product.listOfProp[2].listOfPropItem.length == 1 ? response.data.product.listOfProp[2].listOfPropItem[0].name : ''
                if (this.checkStock3.length != 0 && this.prop3 == '') {
                  if (this.checkStock1.filter(x => x.quantity != 0).length == 1) {
                    var path3 = await this.checkStock3.filter(x => x.quantity != 0)[0].path
                    this.prop3 = response.data.product.listOfProp[2].listOfPropItem.filter( x => path3 == x.propPath)[0].propPath
                    this.prop3Value = response.data.product.listOfProp[2].listOfPropItem.filter( x => path3 == x.propPath)[0].name
                  }
                }
              }
            }
            if (this.prop1 != '' && this.prop2 != '') {
              this.propPath = await this.prop3 == '' ? this.prop2 + ";" + this.prop1 : this.prop2 + ";" + this.prop1 + ";" + this.prop3
              this.quanOfProp = response.data.product.listOfSKUBase[0].quantity
              this.checkQuanAndButton = true
              var findPrice = await this.prod.listOfSKUBase.filter( x => x.propPath == this.propPath)
              if (findPrice.length == 1) {
                this.pricePerItem = findPrice[0].price
              }
            }
            this.checkShop= await response.data
            this.imgList = await this.prod.listOfMainImage
            this.loadProduct = await false
          }
        }
        else if (response.data.status == false) {
          this.tabIndex = 1
          this.urlAdd = response.data.link
          this.loadProduct = false
        }
      }
    },
    selectprop1(path, img, value, showImg){
      this.prop1 = path
      this.prop2Value = value
      this.checkQuanAndButton = true
      if (img) {
        this.imageIcon = img
        this.productImg = img
      }
      this.orderStatus = ''
      this.getQuantity()
    },
    selectprop2(path, img, value, showImg){
      this.prop2 = path
      this.prop1Value = value
      this.checkQuanAndButton = true
      if (img) {
        this.imageIcon = img
        this.productImg = img
      }
      this.orderStatus = ''
      this.getQuantity()
    },
    selectprop3(path, img, value, showImg){
      this.prop3 = path
      this.prop3Value = value
      this.checkQuanAndButton = true
      if (img) {
        this.imageIcon = img
        this.productImg = img
      }
      this.orderStatus = ''
      this.getQuantity()
    },
    changeImg(img){
      this.imageIcon = img
      this.productImg = img
    },
    async thumbnails (){
      if ( await this.imageIcon != '' ) {
        this.productImg = this.imageIcon
      }
      this.imageIcon = ''
    },
    groupBy(array, key){
      const result = {}
      array.forEach(item => {
        if (!result[item[key]]){
          result[item[key]] = []
        }
      result[item[key]].push(item)
      })
      return result
    },
    async getQuantity(){
      if (this.prop1 != '' && this.prop2 != '' && this.prop3 != '') {
        var setPropPath = await this.prop2 + ";" + this.prop1 + ";" + this.prop3
        var checkPath = await this.prod.listOfSKUBase.filter(x => x.propPath == setPropPath)
        if (checkPath.length != 0) {
          this.propPath = await this.prop2 + ";" + this.prop1 + ";" + this.prop3
        } else {
          this.propPath = await this.prop1 + ";" + this.prop2 + ";" + this.prop3
        }
        var price = await this.prod.listOfSKUBase.filter(x => x.propPath == this.propPath)
        if (price.length != 0) {
          this.pricePerItem = price[0].price
        } else {
          this.prod.listOfSKUBase.forEach((e) => {
            if (e.propPath.includes(this.propPath) == true) {
              this.pricePerItem = e.price
            }
          })
        }
        for (let i = 0; i < await this.quantityProd.length; i++) {
          if (this.propPath == this.quantityProd[i].propPath) {
            this.quanOfProp = this.quantityProd[i].quantity
            break;
          } else if (this.quantityProd[i].propPath.includes(this.propPath) == true){
            this.quanOfProp = this.quantityProd[i].quantity
            break;
          } else {
            this.quanOfProp = 0
          }
        }
        return
      }
      if (this.prop1 != '' && this.prop2 != '') {
        var setPropPath = await this.prop2 + ";" + this.prop1
        var checkPath = await this.prod.listOfSKUBase.filter(x => x.propPath == setPropPath)
        if (checkPath.length != 0) {
          this.propPath = await this.prop2 + ";" + this.prop1
        } else {
          this.propPath = await this.prop1 + ";" + this.prop2
        }
        var price = await this.prod.listOfSKUBase.filter(x => x.propPath == this.propPath)
        if (price.length != 0) {
          this.pricePerItem = price[0].price
        } else {
          this.prod.listOfSKUBase.forEach((e) => {
            if (e.propPath.includes(this.propPath) == true) {
              this.pricePerItem = e.price
            }
          })
        }
        for (let i = 0; i < await this.quantityProd.length; i++) {
          if (this.propPath == this.quantityProd[i].propPath) {
            this.quanOfProp = this.quantityProd[i].quantity
            break;
          } else if (this.quantityProd[i].propPath.includes(this.propPath) == true){
            this.quanOfProp = this.quantityProd[i].quantity
            break;
          } else {
            this.quanOfProp = 0
          }
        }
      }
      if (this.prop1 != '' && this.prop2 == '' && this.prod.listOfProp.length == 1) {
        try {
          this.propPath = await this.prop1
          for (let i = 0; i < this.quantityProd.length; i++) {
            if (this.quantityProd[i].propPath.includes(this.propPath) == true) {
              this.priceMinMax = this.quantityProd[i].price
              this.quanOfProp = this.quantityProd[i].quantity
            }
          }
        } catch (error) {
          console.log("prop2 is null");
        }
      }
      if (this.prop1 == '' && this.prop2 != '' && this.prod.listOfProp.length == 1) {
        try {
          this.propPath = await this.prop2
          for (let i = 0; i < this.quantityProd.length; i++) {
            if (this.quantityProd[i].propPath.includes(this.propPath) == true) {
              this.priceMinMax = this.quantityProd[i].price
              this.quanOfProp = this.quantityProd[i].quantity
            }
          }
        } catch (error) {
          console.log("prop1 is null");
        }
      }
    },
    async addProduct1688 () {
      this.loadButton = false
      var keepStatus = ''
      var axios = require('axios');
      var data = JSON.stringify({
        "orderID": this.orderDetail.orderID,
        "customerID": this.customerId,
        "photoLink": this.productImg ? this.productImg : this.prod.listOfMainImage[0],
        "price": this.yuanPriceFromQuantityRange,
        "productLink": this.prod.link,
        "propItemCombination1688": this.quantityProd,
        "remarkCustomer": this.remark,
        "shopName": this.prod.sellerName,
        "subTitle": this.prod.subTitle,
        "title": this.prod.title,
      });

      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/add-product/add-product1688-to-cart',
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
          'Content-Type': 'application/json'
        },
        data : data
      };

      await axios(config)
      .then(function (response) {
        keepStatus = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      this.orderStatus = keepStatus
      this.checkLoadOrder = keepStatus
      this.loadButton = true
    },
    async addProduct1688Prop0() {
      this.loadButton = false
      var combination = [{
        "propPath": "",
        "prop1ID": "",
        "prop1Text": "",
        "prop1Value": "",
        "prop1Img": "",
        "prop2ID": "",
        "prop2Text": "",
        "prop2Value": "",
        "prop2Img": "",
        "isShowText": true,
        "isShowImg": false,
        "tooltip": "",
        "quantity": 0,
        "price": this.prod.quantityRange.filter(x => x.minQuantity <= this.value)[this.prod.quantityRange.filter(x => x.minQuantity <= this.value).length - 1].price.marginPrice,
        "quantityInput": Number(this.value)
      }]
      var keepStatus = ''
      var axios = require('axios');
      var data = JSON.stringify({
        "orderID": this.orderDetail.orderID,
        "customerID": this.customerId,
        "photoLink": this.prod.listOfMainImage[0],
        "price": this.prod.quantityRange.filter(x => x.minQuantity <= this.value)[this.prod.quantityRange.filter(x => x.minQuantity <= this.value).length - 1].price.marginPrice,
        "productLink": this.prod.link,
        "propItemCombination1688": combination,
        "remarkCustomer": this.remark,
        "shopName": this.prod.sellerName,
        "subTitle": this.prod.subTitle,
        "title": this.prod.title,
      });

      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/add-product/add-product1688-to-cart',
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
          'Content-Type': 'application/json'
        },
        data : data
      };

      await axios(config)
      .then(function (response) {
        keepStatus = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      this.orderStatus = keepStatus
      this.checkLoadOrder = keepStatus
      this.loadButton = true
    },
    async addProductTaobao () {
      this.loadButton = false
      var keepStatus = ''
      var imgTaobao = ''
      if(this.prod.listOfProp.length == 0){
        this.prop1TextTaobao = ''
        this.prop2TextTaobao = ''
        this.prop3TextTaobao = ''
      } else if (this.prod.listOfProp.length == 1) {
        this.prop1TextTaobao = this.prod.listOfProp[0].thaiName
        this.prop2TextTaobao = ''
        this.prop3TextTaobao = ''
      } else if (this.prod.listOfProp.length == 2) {
        this.prop1TextTaobao = this.prod.listOfProp[0].thaiName
        this.prop2TextTaobao = this.prod.listOfProp[1].thaiName
        if (this.prod.listOfProp.length == 3) {
          this.prop3TextTaobao = this.prod.listOfProp[2].thaiName
        }
      }
      var axios = require('axios');
      if (this.checkShop.product1688) {
        var data = JSON.stringify({
          "orderID": this.orderDetail.orderID,
          "customerID": this.customerId,
          "photoLink": this.prod.listOfMainImage[0],
          "price": this.prod.price.marginPrice,
          "productLink": this.prod.link,
          "prop1Text": this.prop1TextTaobao,
          "prop1Value": this.prop1Value,
          "prop2Text": this.prop2TextTaobao,
          "prop2Value": this.prop2Value,
          "prop3Text": '',
          "prop3Value": '',
          "propPath": this.prop1,
          "quantity": this.value,
          "remarkCustomer": this.remark,
          "shopName": this.prod.sellerName,
          "subTitle": this.prod.subTitle,
          "title": this.prod.title
        });
      } else if (this.checkShop.product) {
        if (this.productImg) {
          imgTaobao = this.productImg
        } else {
          imgTaobao = this.prod.listOfMainImage[0]
        }
        this.prod.listOfSKUBase.propPath
        var data = JSON.stringify({
          "orderID": this.orderDetail.orderID,
          "customerID": this.customerId,
          "photoLink": imgTaobao,
          "price": this.pricePerItem == null ? this.priceMinMax : this.pricePerItem,
          "productLink": this.prod.link,
          "prop1Text": this.prop1TextTaobao,
          "prop1Value": this.prop1Value,
          "prop2Text": this.prop2TextTaobao,
          "prop2Value": this.prop2Value,
          "prop3Text": this.prop3TextTaobao,
          "prop3Value": this.prop3Value,
          "propPath": this.propPath,
          "quantity": this.valueTaobao,
          "remarkCustomer": this.remark,
          "shopName": this.prod.sellerName,
          "subTitle": this.prod.subTitle,
          "title": this.prod.title
        });
      }

      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/add-product/add-product-to-cart',
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U',
          'Content-Type': 'application/json'
        },
        data : data
      };

      await axios(config)
      .then(function (response) {
        keepStatus = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      this.orderStatus = keepStatus
      this.checkLoadOrder = keepStatus
      this.loadButton = true
    },

    //add manual
    async addProduct() {
      this.loadButtonAdd = await false
      if (this.urlAdd == '' || this.yuanAdd == null || this.yuanAdd == '') {
        if (this.urlAdd == '')
        this.validateUrlAdd = false
        if (this.yuanAdd == null || this.yuanAdd == '')
        this.validateYuanAdd = false
      } else {
        var keepdata = null
        var axios = require('axios');
        var FormData = require('form-data');
        var data = new FormData();
        data.append('OrderID', this.orderDetail.orderID);
        data.append('CustomerID', this.customerId);
        data.append('Image', this.pic64Add);
        data.append('Price', parseInt(this.yuanAdd.replace(/,/g, "")));
        data.append('ProductLink', this.urlAdd);
        data.append('Prop1Value', this.sizeAdd == '' ? null : this.sizeAdd);
        data.append('Prop2Value', this.colorAdd == '' ? null : this.colorAdd);
        data.append('Quantity', this.amountAdd == '' ? null : this.amountAdd);
        data.append('RemarkCustomer', this.remarkAdd == '' ? null : this.remarkAdd);
        data.append('ShopName', this.shopAdd.toString());

        var config = {
            method: 'post',
            url: taobaoService_dotnet +'app/add-product/add-other-product-to-cart',
            data : data,
            headers: {
                'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U',
                'Content-Type': 'multipart/form-data' },
        };
        await axios(config)
        .then(function (response) {
          keepdata = response.data
        })
        .catch(function (error) {
          console.log(error);
        });
      }
      if ( keepdata == 'เพิ่มสินค้าเข้าตะกร้าเรียบร้อย' ) {
        this.orderAddStatus = keepdata
        this.pic64Add = null
        this.yuanAdd = null
        this.urlAdd = ''
        this.sizeAdd = null
        this.colorAdd = null
        this.amountAdd = 1
        this.remarkAdd = null
        this.shopAdd = 1
      }
      this.loadButtonAdd = true
    },
  },
};
</script>

<style>
.text-item {
  width: 200px;
}

.hidden_header {
  display: none;
}

.center {
justify-content: center;
}

.swiper-wrapper {
  height: auto;
  width: auto;
}

.swiper-container{
  width: auto;
  height: auto;
}
@media (min-width: 768px) and (max-width: 991.98px) {
  .modal-dialog {
    max-width: 90%;
  }
 }

 .card {
    margin: 0 auto; /* Added */
    float: none; /* Added */
    margin-bottom: 10px; /* Added */
  }

  @media (max-width: 991.98px) {
    .footer {
      position: fixed;
      left: 0%;
      bottom: -1%;
      width: 100%;
      text-align: center;
    }
   }

  @media (min-width: 991.98px) {
    .footer {
      position: fixed;
      left: -8%;
      bottom: -1%;
      width: 100%;
      text-align: center;
    }
  }

  .td-no {
   width: 50px;
}
</style>
<style scoped lang="scss">
  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
      display: none;
  }
</style>